export const I18N_DATA = {
  "English": {
    "siteTitle": "MyMenuBuddy — Family Food AI",
    "siteTagline": "The Smart AI Cooking Companion for Every Home",
    "navHome": "Home",
    "navSimulator": "AI Kitchen Assistant",
    "navRecipes": "Recipe Explorer",
    "navTiffin": "Tiffin Box",
    "navPantry": "Smart Pantry Chef",
    "navPlanner": "Weekly Meal Planner",
    "navCommunity": "Community Feed",
    "heroTitle": "Never ask <span>'What to cook today?'</span> ever again.",
    "heroSubtitle": "MyMenuBuddy is your personal AI kitchen companion. It remembers your pantry, scales authentic recipes to your family size, and plans weekly meals in English, தமிழ் & हिंदी.",
    "btnTrySimulator": "Chat with AI Chef",
    "btnExploreRecipes": "Explore 45+ Recipes",
    "statRecipes": "Authentic Recipes",
    "statStates": "Regional Cuisines",
    "statLanguages": "3 Languages (EN / தமிழ் / हिंदी)",
    "statPortions": "Dynamic Portion Scaling",
    "simTitle": "Interactive AI Kitchen Assistant",
    "simSubtitle": "Chat with MyMenuBuddy AI to decide what to cook, find recipes, manage your pantry, and scale ingredient quantities.",
    "simOnline": "AI Assistant • Online",
    "simInputPlaceholder": "Ask what to cook, search a recipe, or type /start, /cook...",
    "simSendTooltip": "Send Message",
    "simBotName": "MyMenuBuddy AI Kitchen Assistant",
    "simBotStatus": "Active • Online",
    "simChipCook": "👩‍🍳 What to cook today?",
    "simChipBiryani": "🍗 Chicken Biryani",
    "simChipDosa": "🥞 Ghee Dosa",
    "simChipPantry": "🥬 My Pantry",
    "simChipPlan": "📅 7-Day Plan",
    "simChipSettings": "⚙️ Settings",
    "simSidebarTitle": "💡 MyMenuBuddy Key Features:",
    "simSidebarFeature1": "1. Fresh Suggestions: You will never see repetitive dishes; fresh meals are recommended every time.",
    "simSidebarFeature2": "2. Multilingual Support: Complete ingredients, portions, and methods in English, தமிழ் & हिंदी.",
    "simSidebarFeature3": "3. Dynamic Portion Scaling: Automatically adjusts required grocery measurements for 1 to 8+ people.",
    "simSidebarFeature4": "4. Pantry-Aware Cooking: Tell the AI what you have, and it finds instant recipes you can make right away.",
    "simSidebarCardTitle": "✨ Personalized Cooking",
    "simSidebarCardDesc": "Discover authentic South and North Indian recipes for breakfast, lunch, and dinner in seconds!",
    "simSidebarCardBtn": "Explore 45+ Recipes",
    "simWelcomeText": "🙏 <b>Welcome! I am MyMenuBuddy AI Kitchen Assistant!</b> 👩‍🍳\n\nI help you decide what to cook, scale ingredient portions to your family size, and cook with items in your pantry.\n\n✨ <b>How I can help you:</b>\n• 👩‍🍳 <b>What to cook today?:</b> Instant tailored ideas for breakfast, lunch, and dinner\n• ⚖️ <b>Smart Portion Scaling:</b> Automatic quantity conversion for 1 to 8+ people\n• 🥬 <b>Pantry Cooking:</b> Make delicious dishes using ingredients in your kitchen\n• 🔍 <b>45+ Authentic Recipes:</b> Step-by-step methods in English, தமிழ் & हिंदी\n• 📅 <b>7-Day Meal Planner:</b> Balanced weekly schedules & grocery checklist\n\nTap a quick button below or ask me any cooking question!",
    "simWelcomeButtons": [
      [
        {
          "text": "👩‍🍳 What to cook today?",
          "action": "cmd_cook"
        },
        {
          "text": "🔍 Search Recipes",
          "action": "cmd_find"
        }
      ],
      [
        {
          "text": "🥬 My Kitchen Pantry",
          "action": "cmd_pantry"
        },
        {
          "text": "📅 7-Day Meal Plan",
          "action": "cmd_plan"
        }
      ],
      [
        {
          "text": "⚙️ Profile Settings",
          "action": "cmd_start"
        }
      ]
    ],
    "recipeTitle": "Authentic Regional Recipe Collection",
    "recipeSubtitle": "Explore hand-crafted recipes across Tamil Nadu, Kerala, Andhra, North India, and Global cuisines with dynamic ingredient portion scaling.",
    "searchPlaceholder": "Search by dish name, ingredient (e.g. biryani, paneer, dosa, toor dal)...",
    "filterAllDiets": "All Recipes",
    "filterVeg": "🥦 Vegetarian",
    "filterNonVeg": "🍗 Non-Veg",
    "filterVegan": "🌱 Vegan",
    "filterJain": "🧘 Jain",
    "filterAllTimings": "All Timings",
    "filterBreakfast": "🥞 Breakfast",
    "filterLunch": "🍛 Lunch",
    "filterDinner": "🥘 Dinner",
    "filterSnack": "☕ Snacks",
    "filterQuick": "⚡ < 20 Mins",
    "regionAll": "📍 All 5 Regions (150 Dishes)",
    "regionTN": "🌴 Tamil Nadu (30)",
    "regionKerala": "🥥 Kerala (30)",
    "regionKarnataka": "🌾 Karnataka (30)",
    "regionAndhra": "🌶️ Andhra Pradesh (30)",
    "regionTelangana": "🏛️ Telangana (30)",
    "recipesSearching": "Searching authentic dishes...",
    "recipesFound": "Dishes Found",
    "emptyRecipesTitle": "No matching dishes found",
    "emptyRecipesDesc": "Try clearing filters or search for popular items like 'Dosa', 'Biryani', 'Paneer', 'Sambar'.",
    "cardVegBadge": "🥦 Veg",
    "cardNonVegBadge": "🍗 Non-Veg",
    "cardMins": "mins",
    "cardKeyIngs": "Key Ingredients:",
    "cardScales": "👨‍👩‍👧 Scales 1-8+ Servings",
    "cardEasy": "⚡ Easy",
    "btnRecipeAndPortions": "Recipe & Quantities",
    "btnAskChef": "💬 Ask AI",
    "btnAskChefTitle": "Ask AI Kitchen Assistant about this dish",
    "modalPortionLabel": "⚖️ Portion Scaler (Serving size for people):",
    "modalPortion1to2": "👤 1-2 People (0.5x)",
    "modalPortion3to4": "👨‍👩‍👧 3-4 People (1x)",
    "modalPortion5to6": "👨‍👩‍👧‍👦 5-6 People (1.5x)",
    "modalPortion8plus": "🎉 8+ Feast (2x)",
    "modalTabSummary": "📋 Ingredients & Quick Method",
    "modalTabMasterclass": "👩‍🍳 Masterclass Guided Mode",
    "modalPart": "Part",
    "modalReqIngredients": "🛒 Required Ingredients (for {headcount} people):",
    "modalQuickMethod": "⚡ Quick Method:",
    "modalMasterclassBanner": "👩‍🍳 <b>Masterclass Mode:</b> Check off each step as you complete it. Use the cooking timer below!",
    "modalStep": "Step",
    "modalTimerLabel": "⏱ Cooking Timer:",
    "modalTimerStart": "Start",
    "modalTimerPause": "Pause",
    "modalTimerReset": "Reset",
    "modalBtnCopy": "📋 Copy Recipe",
    "modalBtnAskAI": "💬 Ask AI Assistant",
    "modalCopyAlert": "✅ Recipe and quantities copied to clipboard!",
    "modalCookingTime": "Cooking Time:",
    "modalRegion": "Region:",
    "modalPeople": "people",
    "pantryTitle": "Smart Pantry Chef: Cook With What You Have",
    "pantrySubtitle": "Select ingredients currently available in your kitchen. MyMenuBuddy will find perfect recipes with matching ingredients and calculate missing items!",
    "pantryInputPlaceholder": "Type an ingredient (e.g. paneer, chicken, capsicum) and press Enter...",
    "pantryBtnAdd": "Add Ingredient",
    "pantryBtnDefaults": "Defaults",
    "pantryBtnClear": "Clear All",
    "pantryTapToggle": "💡 Tap any popular pantry item to toggle:",
    "pantryInventoryHeading": "🥬 Your Kitchen Pantry Inventory:",
    "pantryInBasket": "Items in Kitchen Pantry ({count})",
    "pantryItemsCount": "Items",
    "pantryEmptyInventory": "No ingredients selected yet. Click any items above!",
    "pantryResultsHeading": "✨ Dishes You Can Cook With Your Pantry:",
    "pantryCalculating": "Calculating ingredient matches...",
    "pantryEmptyMatches": "Add ingredients above to discover what you can cook right now!",
    "pantryMatchScore": "Match",
    "pantryAllIngsReady": "✅ You have all key ingredients!",
    "pantryNeed": "Need: ",
    "pantryMore": "more",
    "pantryBtnCookThis": "Cook This",
    "plannerTitle": "7-Day AI Meal Planner",
    "plannerSubtitle": "Balanced, healthy weekly meal schedules customized for your family with automatic grocery checklist.",
    "plannerPresetTamil": "🌴 Tamil Nadu Traditional",
    "plannerPresetHealthy": "🥗 High Protein & Healthy Fiber",
    "plannerBtnCopy": "📋 Copy Weekly Grocery Checklist",
    "plannerCopiedAlert": "📋 7-Day Plan & Grocery list copied to clipboard!",
    "plannerDays": {
      "Monday": "Monday",
      "Tuesday": "Tuesday",
      "Wednesday": "Wednesday",
      "Thursday": "Thursday",
      "Friday": "Friday",
      "Saturday": "Saturday",
      "Sunday": "Sunday"
    },
    "plannerSlots": {
      "b": "🥞 Breakfast",
      "l": "🍛 Lunch",
      "s": "☕ Snack",
      "d": "🥘 Dinner"
    },
    "footerDesc": "MyMenuBuddy — Empowering families and home cooks with AI-driven culinary intelligence. Built with React & Node.js.",
    "footerCol1Title": "Quick Navigation",
    "footerCol2Title": "Core AI Features",
    "footerCol3Title": "Authentic Cuisines",
    "fHome": "Home Overview",
    "fAssistant": "AI Kitchen Assistant",
    "fRecipes": "45+ Recipes Explorer",
    "fPantry": "Smart Pantry Chef",
    "fPlanner": "7-Day Meal Planner",
    "fCookToday": "Instant 'Cook Today' Decider",
    "fPortionScaler": "Dynamic 1 to 8+ Portion Scaler",
    "fPantryMatcher": "Kitchen Pantry Matcher",
    "fMasterclass": "Masterclass Guided Mode",
    "fGroceryList": "Automatic Grocery Checklist",
    "fTamilNadu": "Tamil Nadu Traditional",
    "fKerala": "Kerala Syrian & Malabar",
    "fAndhra": "Andhra & Rayalaseema",
    "fNorthIndian": "North Indian & Punjabi",
    "fGlobal": "Indo-Chinese & Global Cuisines",
    "fCopyright": "© 2026 MyMenuBuddy. All rights reserved.",
    "fBadge": "React + Node.js Full-Stack App",
    "fBackToTop": "Back to Top ↑",
    "btnFullscreen": "Fullscreen",
    "btnExitFullscreen": "Exit Fullscreen",
    "settingsTitle": "Settings & Language",
    "settingsLanguage": "Choose Language",
    "settingsLanguageDesc": "Switch between English, தமிழ், and हिंदी",
    "settingsDiet": "Dietary Preference",
    "settingsServings": "Default Family Headcount",
    "settingsClose": "Close Settings"
  },
  "Tamil": {
    "siteTitle": "மைமெனுபடி — குடும்ப உணவு AI",
    "siteTagline": "உங்கள் இல்லத்திற்கான அறிவார்ந்த சமையல் வழிகாட்டி",
    "navHome": "முகப்பு",
    "navSimulator": "AI சமையல் தோழி",
    "navRecipes": "சமையல் குறிப்புகள்",
    "navTiffin": "டிபன் பாக்ஸ்",
    "navPantry": "சமையலறை செஃப்",
    "navPlanner": "வாராந்திரத் திட்டம்",
    "navCommunity": "சமையல் அரங்கம்",
    "heroTitle": "<span>'இன்று என்ன சமைப்பது?'</span> என்ற கவலை இனி வேண்டாம்.",
    "heroSubtitle": "மைமெனுபடி உங்கள் வீட்டில் உள்ள பொருட்களை நினைவில் கொண்டு, குடும்ப எண்ணிக்கைக்கு ஏற்ப அளவுகளை மாற்றி, தமிழ், ஆங்கிலம் மற்றும் இந்தியில் வழிகாட்டும் தனிப்பட்ட AI சமையல் தோழி.",
    "btnTrySimulator": "AI சமையல் தோழியிடம் பேசுங்கள்",
    "btnExploreRecipes": "45+ குறிப்புகளை காண்க",
    "statRecipes": "பாரம்பரிய சமையல்கள்",
    "statStates": "மாநில உணவு வகைகள்",
    "statLanguages": "3 மொழிகள் (தமிழ் / EN / हिंदी)",
    "statPortions": "தானியங்கி அளவு மாற்றம்",
    "simTitle": "அறிவார்ந்த AI சமையல் தோழி",
    "simSubtitle": "இன்று என்ன சமைக்கலாம் என்பதை தீர்மானிக்கவும், அளவுகளை கணக்கிடவும் மைமெனுபடி AI-யிடம் உரையாடுங்கள்.",
    "simOnline": "AI தோழி • ஆன்லைன்",
    "simInputPlaceholder": "என்ன சமைக்கலாம் என கேட்கவும் (/start, /cook, biryani)...",
    "simSendTooltip": "செய்தி அனுப்புக",
    "simBotName": "மைமெனுபடி AI சமையல் தோழி",
    "simBotStatus": "செயலில் உள்ளது • Online",
    "simChipCook": "👩‍🍳 இன்று என்ன சமைப்பது?",
    "simChipBiryani": "🍗 சிக்கன் பிரியாணி",
    "simChipDosa": "🥞 நெய் தோசை",
    "simChipPantry": "🥬 என் பொருட்கள்",
    "simChipPlan": "📅 7-நாள் திட்டம்",
    "simChipSettings": "⚙️ அமைப்புகள்",
    "simSidebarTitle": "💡 மைமெனுபடி சிறப்பம்சங்கள்:",
    "simSidebarFeature1": "1. புதிய பரிந்துரைகள்: பார்த்த உணவே மீண்டும் வராமல், ஒவ்வொரு முறையும் புதிய உணவுகள் மட்டுமே பரிந்துரைக்கப்படும்.",
    "simSidebarFeature2": "2. மும்மொழி ஆதரவு: செய்முறைகள் மற்றும் அளவுகள் தமிழ், ஆங்கிலம், இந்தியில் கிடைக்கும்.",
    "simSidebarFeature3": "3. துல்லிய அளவு மாற்றம்: 1 முதல் 8+ நபர்களுக்கு ஏற்ப மளிகைப் பொருட்களின் அளவுகள் மாறும்.",
    "simSidebarFeature4": "4. சமையலறை சேமிப்பு: வீட்டில் உள்ள பொருட்களை சொன்னால் உடனே சமைக்கும் வழிகள் கிடைக்கும்.",
    "simSidebarCardTitle": "✨ தனிப்பயன் சமையல்",
    "simSidebarCardDesc": "காலை, மதியம், இரவு உணவுகளுக்கு பாரம்பரிய சுவைகளை நொடியில் கண்டறியுங்கள்!",
    "simSidebarCardBtn": "45+ சமையல் குறிப்புகள் காண்க",
    "simWelcomeText": "🙏 <b>வணக்கம்! நான் மைமெனுபடி AI சமையல் தோழி!</b> 👩‍🍳\n\nஉங்களுக்கு தேவையான உணவுகளை தேர்ந்தெடுக்கவும், குடும்ப நபர்களுக்கு ஏற்ப அளவுகளை கணக்கிடவும் நான் உதவுகிறேன்.\n\n✨ <b>நான் எப்படி உங்களுக்கு உதவுவேன்:</b>\n• 👩‍🍳 <b>இன்று என்ன சமைப்பது?:</b> காலை, மதியம், இரவு உணவிற்கான உடனடி பரிந்துரைகள்\n• ⚖️ <b>துல்லிய அளவு மாற்றம்:</b> 1 முதல் 8+ நபர்களுக்கு ஏற்ப தானியங்கி பொருட்கள் அளவீடு\n• 🥬 <b>சமையலறை பொருட்கள்:</b> வீட்டில் உள்ள பொருட்களை வைத்து உடனே சமைக்கும் வழிகள்\n• 🔍 <b>45+ பாரம்பரிய உணவுகள்:</b> முழு செய்முறையும் சுத்தமான தமிழில்!\n• 📅 <b>7-நாள் உணவுத் திட்டம்:</b> வாராந்திர உணவு அட்டவணை & மளிகைப் பட்டியல்\n\nகீழே உள்ள பட்டனை தட்டவும் அல்லது உங்கள் கேள்வியை கேளுங்கள்!",
    "simWelcomeButtons": [
      [
        {
          "text": "👩‍🍳 இன்று என்ன சமைப்பது?",
          "action": "cmd_cook"
        },
        {
          "text": "🔍 சமையல் குறிப்பு தேட",
          "action": "cmd_find"
        }
      ],
      [
        {
          "text": "🥬 என் சமையலறை பொருட்கள்",
          "action": "cmd_pantry"
        },
        {
          "text": "📅 7-நாள் உணவுத் திட்டம்",
          "action": "cmd_plan"
        }
      ],
      [
        {
          "text": "⚙️ சுயவிவர அமைப்பு",
          "action": "cmd_start"
        }
      ]
    ],
    "recipeTitle": "சுவையான பாரம்பரிய சமையல் தொகுப்பு",
    "recipeSubtitle": "தமிழ்நாடு, கேரளா, ஆந்திரா, வட இந்தியா சுவைகளை குடும்ப எண்ணிக்கைக்கு ஏற்ப அளவுகளோடு சமைத்து அசத்துங்கள்.",
    "searchPlaceholder": "உணவு அல்லது பொருளைத் தேடுங்கள் (எ.கா. பிரியாணி, பன்னீர், தோசை)...",
    "filterAllDiets": "அனைத்து ரெசிபிகள்",
    "filterVeg": "🥦 சைவம்",
    "filterNonVeg": "🍗 அசைவம்",
    "filterVegan": "🌱 வீகன்",
    "filterJain": "🧘 ஜெயின்",
    "filterAllTimings": "அனைத்து நேரங்கள்",
    "filterBreakfast": "🥞 காலை டிபன்",
    "filterLunch": "🍛 மதிய உணவு",
    "filterDinner": "🥘 இரவு உணவு",
    "filterSnack": "☕ சிற்றுண்டி",
    "filterQuick": "⚡ < 20 நிமிடம்",
    "regionAll": "📍 அனைத்து 5 மாநிலங்கள் (150 உணவுகள்)",
    "regionTN": "🌴 தமிழ்நாடு (30)",
    "regionKerala": "🥥 கேரளா (30)",
    "regionKarnataka": "🌾 கர்நாடகா (30)",
    "regionAndhra": "🌶️ ஆந்திர பிரதேசம் (30)",
    "regionTelangana": "🏛️ தெலுங்கானா (30)",
    "recipesSearching": "சுவையான உணவுகள் தேடப்படுகின்றன...",
    "recipesFound": "உணவுகள் கண்டறியப்பட்டன",
    "emptyRecipesTitle": "பொருத்தமான உணவுகள் ஏதும் கிடைக்கவில்லை",
    "emptyRecipesDesc": "வடிகட்டிகளை மாற்றி அல்லது 'தோசை', 'பிரியாணி', 'சாம்பார்' என தேடவும்.",
    "cardVegBadge": "🥦 சைவம்",
    "cardNonVegBadge": "🍗 அசைவம்",
    "cardMins": "நிமிடங்கள்",
    "cardKeyIngs": "முக்கிய பொருட்கள்:",
    "cardScales": "👨‍👩‍👧 1-8+ நபர்களுக்கு அளவு மாறும்",
    "cardEasy": "⚡ சுலபம்",
    "btnRecipeAndPortions": "செய்முறை & அளவுகள்",
    "btnAskChef": "💬 கேட்க",
    "btnAskChefTitle": "AI சமையல் தோழியிடம் இந்த உணவை பற்றி கேட்க",
    "modalPortionLabel": "⚖️ உணவு அளவு மாற்றி (தேவையான நபர்கள் எண்ணிக்கை):",
    "modalPortion1to2": "👤 1-2 நபர்கள் (0.5x)",
    "modalPortion3to4": "👨‍👩‍👧 3-4 நபர்கள் (1x)",
    "modalPortion5to6": "👨‍👩‍👧‍👦 5-6 நபர்கள் (1.5x)",
    "modalPortion8plus": "🎉 8+ விருந்து (2x)",
    "modalTabSummary": "📋 பொருட்கள் & செய்முறை",
    "modalTabMasterclass": "👩‍🍳 மாஸ்டர்கிளாஸ் நேரடி முறை",
    "modalPart": "பாகம்",
    "modalReqIngredients": "🛒 தேவையான பொருட்கள் ({headcount} நபர்களுக்கு):",
    "modalQuickMethod": "⚡ விரைவு செய்முறை:",
    "modalMasterclassBanner": "👩‍🍳 <b>மாஸ்டர்கிளாஸ் முறை:</b> ஒவ்வொரு படியாக செய்து முடித்து டிக் செய்யவும். டைமரை பயன்படுத்தவும்!",
    "modalStep": "படி",
    "modalTimerLabel": "⏱ சமையல் டைமர்:",
    "modalTimerStart": "தொடங்கு",
    "modalTimerPause": "நிறுத்து",
    "modalTimerReset": "மீட்டமை",
    "modalBtnCopy": "📋 நகலெடு",
    "modalBtnAskAI": "💬 AI தோழியிடம் கேட்க",
    "modalCopyAlert": "✅ செய்முறை மற்றும் அளவுகள் நகலெடுக்கப்பட்டது!",
    "modalCookingTime": "சமைக்கும் நேரம்:",
    "modalRegion": "பகுதி:",
    "modalPeople": "நபர்கள்",
    "pantryTitle": "சமையலறை செஃப்: உள்ள பொருட்களை வைத்து சமையுங்கள்",
    "pantrySubtitle": "உங்கள் வீட்டில் இப்போது இருக்கும் பொருட்களைத் தேர்ந்தெடுங்கள். மைமெனுபடி உடனடியாக செய்யக்கூடிய உணவுகளை பரிந்துரைக்கும்!",
    "pantryInputPlaceholder": "பொருளின் பெயரை தட்டச்சு செய்து Enter அழுத்தவும் (எ.கா. பன்னீர், சிக்கன்)...",
    "pantryBtnAdd": "பொருளை சேர்",
    "pantryBtnDefaults": "வழக்கமானவை",
    "pantryBtnClear": "அனைத்தையும் நீக்கு",
    "pantryTapToggle": "💡 விரைவாக சேர்க்க ஏதேனும் பொருளைத் தட்டவும்:",
    "pantryInventoryHeading": "🥬 உங்கள் சமையலறை சேமிப்புப் பட்டியல்:",
    "pantryInBasket": "சமையலறையில் உள்ள பொருட்கள் ({count})",
    "pantryItemsCount": "பொருட்கள்",
    "pantryEmptyInventory": "எந்தப் பொருட்களும் இன்னும் தேர்ந்தெடுக்கப்படவில்லை. மேலே உள்ளவற்றைத் தட்டவும்!",
    "pantryResultsHeading": "✨ உங்கள் வீட்டுப் பொருட்களை வைத்து செய்யக்கூடிய உணவுகள்:",
    "pantryCalculating": "பொருட்களின் பொருத்தம் கணக்கிடப்படுகிறது...",
    "pantryEmptyMatches": "இப்போது சமைக்கக்கூடிய உணவுகளை அறிய மேலே பொருட்களைச் சேர்க்கவும்!",
    "pantryMatchScore": "பொருத்தம்",
    "pantryAllIngsReady": "✅ அனைத்து முக்கிய பொருட்களும் உங்களிடம் உள்ளன!",
    "pantryNeed": "தேவை: ",
    "pantryMore": "கூடுதல்",
    "pantryBtnCookThis": "சமைக்க",
    "plannerTitle": "7-நாள் வாராந்திர உணவுத் திட்டம்",
    "plannerSubtitle": "குடும்ப ஆரோக்கியத்திற்கு ஏற்ற சமச்சீரான 7 நாள் உணவு அட்டவணை மற்றும் மளிகைப் பட்டியல்.",
    "plannerPresetTamil": "🌴 தமிழ்நாடு பாரம்பரிய உணவுகள்",
    "plannerPresetHealthy": "🥗 ஆரோக்கியமான அதிக புரத உணவுகள்",
    "plannerBtnCopy": "📋 வாராந்திர மளிகைப் பட்டியலை நகலெடு",
    "plannerCopiedAlert": "📋 7-நாள் உணவுத் திட்டம் & மளிகைப் பட்டியல் நகலெடுக்கப்பட்டது!",
    "plannerDays": {
      "Monday": "திங்கள்",
      "Tuesday": "செவ்வாய்",
      "Wednesday": "புதன்",
      "Thursday": "வியாழன்",
      "Friday": "வெள்ளி",
      "Saturday": "சனி",
      "Sunday": "ஞாயிறு"
    },
    "plannerSlots": {
      "b": "🥞 காலை டிபன்",
      "l": "🍛 மதிய சாப்பாடு",
      "s": "☕ மாலை சிற்றுண்டி",
      "d": "🥘 இரவு உணவு"
    },
    "footerDesc": "மைமெனுபடி — குடும்பங்களின் தினசரி சமையலை எளிதாக்கும் அறிவார்ந்த உணவு AI தளம். ரியாக்ட் & நோட் கொண்டு உருவாக்கப்பட்டது.",
    "footerCol1Title": "விரைவு இணைப்புகள்",
    "footerCol2Title": "AI சிறப்பு அம்சங்கள்",
    "footerCol3Title": "பாரம்பரிய சுவைகள்",
    "fHome": "முகப்பு மேலோட்டம்",
    "fAssistant": "AI சமையல் தோழி",
    "fRecipes": "45+ சமையல் குறிப்புகள்",
    "fPantry": "சமையலறை செஃப்",
    "fPlanner": "7-நாள் உணவுத் திட்டம்",
    "fCookToday": "இன்று என்ன சமைப்பது?",
    "fPortionScaler": "1 முதல் 8+ நபர்களுக்கான அளவு மாற்றி",
    "fPantryMatcher": "வீட்டுப் பொருட்களை வைத்து சமையல்",
    "fMasterclass": "மாஸ்டர்கிளாஸ் நேரடி சமையல்",
    "fGroceryList": "தானியங்கி மளிகைப் பட்டியல்",
    "fTamilNadu": "தமிழ்நாடு பாரம்பரிய உணவுகள்",
    "fKerala": "கேரளா ஸ்பெஷல் உணவுகள்",
    "fAndhra": "ஆந்திரா காரசார சுவைகள்",
    "fNorthIndian": "பஞ்சாபி & வட இந்திய சுவைகள்",
    "fGlobal": "சீன & உலகளாவிய உணவுகள்",
    "fCopyright": "© 2026 மைமெனுபடி. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    "fBadge": "ரியாக்ட் + நோட் முழுமையான தளம்",
    "fBackToTop": "மேலே செல்க ↑",
    "btnFullscreen": "முழுத்திரை",
    "btnExitFullscreen": "முழுத்திரையிலிருந்து வெளியேறு",
    "settingsTitle": "அமைப்புகள் & மொழி",
    "settingsLanguage": "மொழியைத் தேர்ந்தெடுக்கவும்",
    "settingsLanguageDesc": "தமிழ், ஆங்கிலம் அல்லது இந்திக்கு மாறவும்",
    "settingsDiet": "உணவு பழக்கம்",
    "settingsServings": "குடும்ப உறுப்பினர்கள்",
    "settingsClose": "அமைப்புகளை மூடு"
  },
  "Hindi": {
    "siteTitle": "मायमेनुबडी — फैमिली फ़ूड AI",
    "siteTagline": "हर घर के लिए स्मार्ट AI कुकिंग साथी",
    "navHome": "होम",
    "navSimulator": "AI किचन असिस्टेंट",
    "navRecipes": "रेसिपी एक्सप्लोरर",
    "navTiffin": "टिफिन बॉक्स",
    "navPantry": "स्मार्ट पैंट्री शेफ",
    "navPlanner": "साप्ताहिक भोजन योजना",
    "navCommunity": "कम्युनिटी रसोई",
    "heroTitle": "अब कभी मत पूछिए <span>'आज क्या पकाएं?'</span>",
    "heroSubtitle": "मायमेनुबडी आपका व्यक्तिगत AI किचन साथी है। यह आपकी रसोई की सामग्री को याद रखता है, परिवार के अनुसार मात्रा तय करता है और हिंदी, अंग्रेजी व तमिल में भोजन योजना बनाता है।",
    "btnTrySimulator": "AI शेफ से बात करें",
    "btnExploreRecipes": "45+ रेसिपी देखें",
    "statRecipes": "प्रामाणिक रेसिपी",
    "statStates": "क्षेत्रीय व्यंजन",
    "statLanguages": "3 भाषाएं (हिंदी / EN / தமிழ்)",
    "statPortions": "सटीक मात्रा माप",
    "simTitle": "इंटरैक्टिव AI किचन असिस्टेंट",
    "simSubtitle": "आज क्या पकाना है, रेसिपी खोजना, रसोई का सामान प्रबंधित करना और सामग्री की मात्रा तय करने के लिए मायमेनुबडी AI से बात करें।",
    "simOnline": "AI असिस्टेंट • ऑनलाइन",
    "simInputPlaceholder": "पूछें आज क्या बनाएं, रेसिपी खोजें (/start, /cook, biryani)...",
    "simSendTooltip": "संदेश भेजें",
    "simBotName": "मायमेनुबडी AI किचन असिस्टेंट",
    "simBotStatus": "सक्रिय • ऑनलाइन",
    "simChipCook": "👩‍🍳 आज क्या पकाएं?",
    "simChipBiryani": "🍗 चिकन बिरयानी",
    "simChipDosa": "🥞 घी डोसा",
    "simChipPantry": "🥬 मेरी पैंट्री",
    "simChipPlan": "📅 7-दिन की योजना",
    "simChipSettings": "⚙️ सेटिंग्स",
    "simSidebarTitle": "💡 मायमेनुबडी की मुख्य विशेषताएं:",
    "simSidebarFeature1": "1. ताज़ा व्यंजन सुझाव: बार-बार वही खाना नहीं आएगा; हर बार नए और स्वादिष्ट विकल्प मिलेंगे।",
    "simSidebarFeature2": "2. त्रिभाषी समर्थन: सभी रेसिपी, मात्रा और विधियां हिंदी, अंग्रेजी और तमिल में उपलब्ध हैं।",
    "simSidebarFeature3": "3. मात्रा समायोजन: 1 से 8+ लोगों के अनुसार सामग्री का माप अपने आप बदल जाता है।",
    "simSidebarFeature4": "4. पैंट्री कुकिंग: रसोई में उपलब्ध सामान बताएं, तुरंत बनने वाले स्वादिष्ट व्यंजन पाएं।",
    "simSidebarCardTitle": "✨ मनपसंद कुकिंग",
    "simSidebarCardDesc": "नाश्ते, दोपहर और रात के खाने के लिए पारंपरिक स्वादों को पल भर में खोजें!",
    "simSidebarCardBtn": "45+ रेसिपी देखें",
    "simWelcomeText": "🙏 <b>नमस्ते! मैं मायमेनुबडी AI किचन असिस्टेंट हूँ!</b> 👩‍🍳\n\nमैं आपको यह तय करने में मदद करती हूँ कि आज क्या पकाना है, परिवार के अनुसार सामग्री की मात्रा मापती हूँ और रसोई में मौजूद सामान से खाना बनाने में मदद करती हूँ।\n\n✨ <b>मैं आपकी कैसे मदद कर सकती हूँ:</b>\n• 👩‍🍳 <b>आज क्या पकाएं?:</b> नाश्ता, दोपहर और रात के खाने के त्वरित सुझाव\n• ⚖️ <b>मात्रा समायोजन:</b> 1 से 8+ लोगों के लिए सामग्री का सटीक माप\n• 🥬 <b>पैंट्री कुकिंग:</b> घर में उपलब्ध सामान से स्वादिष्ट व्यंजन बनाएं\n• 🔍 <b>45+ प्रामाणिक रेसिपी:</b> बनाने की पूरी विधि हिंदी में!\n• 📅 <b>7-दिन की भोजन योजना:</b> साप्ताहिक मेनू और किराने की सूची\n\nनीचे दिए गए बटन पर टैप करें या अपना प्रश्न पूछें!",
    "simWelcomeButtons": [
      [
        {
          "text": "👩‍🍳 आज क्या पकाएं?",
          "action": "cmd_cook"
        },
        {
          "text": "🔍 रेसिपी खोजें",
          "action": "cmd_find"
        }
      ],
      [
        {
          "text": "🥬 मेरी पैंट्री सामग्री",
          "action": "cmd_pantry"
        },
        {
          "text": "📅 7-दिन की भोजन योजना",
          "action": "cmd_plan"
        }
      ],
      [
        {
          "text": "⚙️ प्रोफ़ाइल सेटिंग्स",
          "action": "cmd_start"
        }
      ]
    ],
    "recipeTitle": "पारंपरिक क्षेत्रीय व्यंजनों का संग्रह",
    "recipeSubtitle": "तमिलनाडु, केरल, आंध्र, उत्तर भारत और अंतर्राष्ट्रीय व्यंजनों को परिवार के आकार के अनुसार मात्रा के साथ पकाएं।",
    "searchPlaceholder": "व्यंजन या सामग्री का नाम खोजें (जैसे बिरयानी, पनीर, डोसा, दाल)...",
    "filterAllDiets": "सभी रेसिपीज़",
    "filterVeg": "🥦 शाकाहारी",
    "filterNonVeg": "🍗 मांसाहारी",
    "filterVegan": "🌱 वीगन",
    "filterJain": "🧘 जैन",
    "filterAllTimings": "सभी समय",
    "filterBreakfast": "🥞 नाश्ता",
    "filterLunch": "🍛 दोपहर का भोजन",
    "filterDinner": "🥘 रात का भोजन",
    "filterSnack": "☕ स्नैक्स",
    "filterQuick": "⚡ < 20 मिनट",
    "regionAll": "📍 सभी 5 राज्य (150 व्यंजन)",
    "regionTN": "🌴 तमिलनाडु (30)",
    "regionKerala": "🥥 केरल (30)",
    "regionKarnataka": "🌾 कर्नाटक (30)",
    "regionAndhra": "🌶️ आंध्र प्रदेश (30)",
    "regionTelangana": "🏛️ तेलंगाना (30)",
    "recipesSearching": "स्वादिष्ट व्यंजन खोजे जा रहे हैं...",
    "recipesFound": "व्यंजन मिले",
    "emptyRecipesTitle": "कोई मेल खाता व्यंजन नहीं मिला",
    "emptyRecipesDesc": "फ़िल्टर साफ़ करें या 'डोसा', 'बिरयानी', 'पनीर', 'सांभर' जैसे लोकप्रिय व्यंजन खोजें।",
    "cardVegBadge": "🥦 शाकाहारी",
    "cardNonVegBadge": "🍗 मांसाहारी",
    "cardMins": "मिनट",
    "cardKeyIngs": "मुख्य सामग्री:",
    "cardScales": "👨‍👩‍👧 1-8+ लोगों के लिए मात्रा",
    "cardEasy": "⚡ आसान",
    "btnRecipeAndPortions": "रेसिपी और मात्रा",
    "btnAskChef": "💬 AI से पूछें",
    "btnAskChefTitle": "इस व्यंजन के बारे में AI शेफ से पूछें",
    "modalPortionLabel": "⚖️ मात्रा समायोजक (परिवार के सदस्यों की संख्या):",
    "modalPortion1to2": "👤 1-2 लोग (0.5x)",
    "modalPortion3to4": "👨‍👩‍👧 3-4 लोग (1x)",
    "modalPortion5to6": "👨‍👩‍👧‍👦 5-6 लोग (1.5x)",
    "modalPortion8plus": "🎉 8+ दावत (2x)",
    "modalTabSummary": "📋 सामग्री और त्वरित विधि",
    "modalTabMasterclass": "👩‍🍳 मास्टरक्लास गाइडेड मोड",
    "modalPart": "भाग",
    "modalReqIngredients": "🛒 आवश्यक सामग्री ({headcount} लोगों के लिए):",
    "modalQuickMethod": "⚡ त्वरित विधि:",
    "modalMasterclassBanner": "👩‍🍳 <b>मास्टरक्लास मोड:</b> खाना बनाते समय प्रत्येक चरण को पूरा करके टिक करें। कुकिंग टाइमर का उपयोग करें!",
    "modalStep": "चरण",
    "modalTimerLabel": "⏱ कुकिंग टाइमर:",
    "modalTimerStart": "शुरू करें",
    "modalTimerPause": "रोकें",
    "modalTimerReset": "रीसेट",
    "modalBtnCopy": "📋 रेसिपी कॉपी करें",
    "modalBtnAskAI": "💬 AI असिस्टेंट से पूछें",
    "modalCopyAlert": "✅ रेसिपी और सामग्री की मात्रा क्लिपबोर्ड पर कॉपी हो गई!",
    "modalCookingTime": "पकाने का समय:",
    "modalRegion": "क्षेत्र:",
    "modalPeople": "लोग",
    "pantryTitle": "स्मार्ट पैंट्री शेफ: जो है उसी से पकाएं",
    "pantrySubtitle": "अपनी रसोई में मौजूद सामग्री चुनें। मायमेनुबडी तुरंत बनने वाले स्वादिष्ट व्यंजन सुझाएगा!",
    "pantryInputPlaceholder": "सामग्री का नाम लिखें (जैसे पनीर, चिकन, शिमला मिर्च)...",
    "pantryBtnAdd": "सामग्री जोड़ें",
    "pantryBtnDefaults": "सामान्य सामग्री",
    "pantryBtnClear": "सब साफ़ करें",
    "pantryTapToggle": "💡 त्वरित जोड़ने के लिए किसी भी लोकप्रिय सामग्री पर टैप करें:",
    "pantryInventoryHeading": "🥬 आपकी रसोई की सामग्री सूची:",
    "pantryInBasket": "रसोई में उपलब्ध सामग्री ({count})",
    "pantryItemsCount": "सामग्री",
    "pantryEmptyInventory": "अभी तक कोई सामग्री नहीं चुनी गई। ऊपर दिए गए विकल्पों पर क्लिक करें!",
    "pantryResultsHeading": "✨ इस सामग्री से आप ये व्यंजन बना सकते हैं:",
    "pantryCalculating": "सामग्री का मिलान किया जा रहा है...",
    "pantryEmptyMatches": "व्यंजन खोजने के लिए ऊपर सामग्री जोड़ें!",
    "pantryMatchScore": "मैच",
    "pantryAllIngsReady": "✅ आपके पास सभी मुख्य सामग्रियां मौजूद हैं!",
    "pantryNeed": "आवश्यक: ",
    "pantryMore": "और",
    "pantryBtnCookThis": "यह पकाएं",
    "plannerTitle": "7-दिवसीय AI भोजन योजना",
    "plannerSubtitle": "परिवार के स्वास्थ्य के लिए संतुलित साप्ताहिक भोजन मेनू और स्वचालित किराने की सूची।",
    "plannerPresetTamil": "🌴 पारंपरिक दक्षिण भारतीय",
    "plannerPresetHealthy": "🥗 उच्च प्रोटीन और फाइबर",
    "plannerBtnCopy": "📋 साप्ताहिक किराने की सूची कॉपी करें",
    "plannerCopiedAlert": "📋 7-दिन की योजना और किराने की सूची कॉपी हो गई!",
    "plannerDays": {
      "Monday": "सोमवार",
      "Tuesday": "मंगलवार",
      "Wednesday": "बुधवार",
      "Thursday": "गुरुवार",
      "Friday": "शुक्रवार",
      "Saturday": "शनिवार",
      "Sunday": "रविवार"
    },
    "plannerSlots": {
      "b": "🥞 नाश्ता",
      "l": "🍛 दोपहर का खाना",
      "s": "☕ शाम का नाश्ता",
      "d": "🥘 रात का खाना"
    },
    "footerDesc": "मायमेनुबडी — परिवारों के दैनिक भोजन को आसान बनाने वाला स्मार्ट AI प्लेटफॉर्म। रिएक्ट और नोड पर निर्मित।",
    "footerCol1Title": "त्वरित नेविगेशन",
    "footerCol2Title": "AI विशेषताएं",
    "footerCol3Title": "पारंपरिक स्वाद",
    "fHome": "होम ओवरव्यू",
    "fAssistant": "AI किचन असिस्टेंट",
    "fRecipes": "45+ रेसिपी एक्सप्लोरर",
    "fPantry": "स्मार्ट पैंट्री शेफ",
    "fPlanner": "7-दिन की भोजन योजना",
    "fCookToday": "आज क्या पकाएं?",
    "fPortionScaler": "1 से 8+ लोगों के लिए मात्रा स्केलर",
    "fPantryMatcher": "रसोई पैंट्री मैचर",
    "fMasterclass": "मास्टरक्लास गाइडेड मोड",
    "fGroceryList": "स्वचालित किराने की सूची",
    "fTamilNadu": "तमिलनाडु पारंपरिक",
    "fKerala": "केरल स्पेशल",
    "fAndhra": "आंध्र मसालेदार स्वाद",
    "fNorthIndian": "उत्तर भारतीय व पंजाबी",
    "fGlobal": "अंतर्राष्ट्रीय व्यंजन",
    "fCopyright": "© 2026 मायमेनुबडी। सर्वाधिकार सुरक्षित।",
    "fBadge": "रिएक्ट + नोड पूर्ण-स्टैक ऐप",
    "fBackToTop": "शीर्ष पर जाएं ↑",
    "btnFullscreen": "पूर्ण स्क्रीन",
    "btnExitFullscreen": "पूर्ण स्क्रीन से बाहर निकलें",
    "settingsTitle": "सेटिंग्स और भाषा",
    "settingsLanguage": "भाषा चुनें",
    "settingsLanguageDesc": "हिंदी, தமிழ் या English में बदलें",
    "settingsDiet": "आहार वरीयता",
    "settingsServings": "डिफ़ॉल्ट लोग",
    "settingsClose": "सेटिंग्स बंद करें"
  },
  "Telugu": {
    "siteTitle": "మైమెనూబడ్డీ — ఫ్యామిలీ ఫుడ్ AI",
    "siteTagline": "ప్రతి ఇంటికి స్మార్ట్ AI వంటల మార్గదర్శి",
    "navHome": "హోమ్",
    "navSimulator": "AI కిచెన్ అసిస్టెంట్",
    "navRecipes": "రెసిపీ ఎక్స్‌ప్లోరర్",
    "navTiffin": "టిఫిన్ బాక్స్",
    "navPantry": "స్మార్ట్ ప్యాంట్రీ చెఫ్",
    "navPlanner": "వారపు భోజన ప్రణాళిక",
    "navCommunity": "కమ్యూనిటీ ఫీడ్",
    "heroTitle": "ఇకపై <span>'ఈరోజు ఏం వండాలి?'</span> అని ఎప్పుడూ ఆలోచించకండి.",
    "heroSubtitle": "మైమెనూబడ్డీ మీ ఇంట్లో ఉన్న వస్తువులను గుర్తుంచుకుని, కుటుంబ పరిమాణానికి సరిపడా కొలతలను అందించి, తెలుగు, தமிழ், हिंदी మరియు English లో సహాయపడే మీ పర్సనల్ AI చెఫ్.",
    "btnTrySimulator": "AI చెఫ్‌తో మాట్లాడండి",
    "btnExploreRecipes": "45+ వంటకాలను చూడండి",
    "statRecipes": "సాంప్రదాయ వంటకాలు",
    "statStates": "ప్రాంతీయ రుచులు",
    "statLanguages": "5 భాషలు (తెలుగు / தமிழ் / हिंदी / عربي / EN)",
    "statPortions": "ఆటోమేటిక్ కొలతల స్కేలింగ్",
    "simTitle": "ఇంటరాక్టివ్ AI కిచెన్ అసిస్టెంట్",
    "simSubtitle": "ఈరోజు ఏం వండాలో నిర్ణయించుకోవడానికి, రెసిపీలు కనుగొనడానికి మరియు ప్యాంట్రీని నిర్వహించడానికి మైమెనూబడ్డీతో చాట్ చేయండి.",
    "simOnline": "AI అసిస్టెంట్ • ఆన్‌లైన్",
    "simInputPlaceholder": "ఏం వండాలని అడగండి, రెసిపీ శోధించండి లేదా /start, /cook అని టైప్ చేయండి...",
    "simSendTooltip": "సందేశం పంపండి",
    "simBotName": "మైమెనూబడ్డీ AI కిచెన్ అసిస్టెంట్",
    "simBotStatus": "యాక్టివ్ • Online",
    "simChipCook": "👩‍🍳 ఈరోజు ఏం వండాలి?",
    "simChipBiryani": "🍗 చికెన్ బిర్యానీ",
    "simChipDosa": "🥞 నేతి దోశ",
    "simChipPantry": "🥬 నా ప్యాంట్రీ",
    "simChipPlan": "📅 7 రోజుల ప్లాన్",
    "simChipSettings": "⚙️ సెట్టింగ్స్",
    "simSidebarTitle": "💡 మైమెనూబడ్డీ ముఖ్య ఫీచర్లు:",
    "simSidebarFeature1": "1. తాజా సలహాలు: రోజూ ఒకే రకం కాకుండా ప్రతిసారీ కొత్త వంటకాలు సూచించబడతాయి.",
    "simSidebarFeature2": "2. బహుభాషా మద్దతు: తెలుగు, తమిళం, హిందీ, అరబిక్ మరియు ఇంగ్లీష్‌లలో పూర్తి రెసిపీ వివరాలు.",
    "simSidebarFeature3": "3. కుటుంబ పరిమాణ కొలతలు: 1 నుండి 8+ వ్యక్తుల వరకు అవసరమైన సరుకుల కొలతలు ఆటోమేటిక్‌గా మారుతాయి.",
    "simSidebarFeature4": "4. ప్యాంట్రీ వంటకాలు: మీ దగ్గర ఉన్న పదార్థాలను చెప్పండి, తక్షణమే వండగల వంటకాలను కనుగొంటుంది.",
    "simSidebarCardTitle": "✨ వ్యక్తిగతీకరించిన వంటకాలు",
    "simSidebarCardDesc": "దక్షిణ మరియు ఉత్తర భారత సాంప్రదాయ అల్పాహారం, భోజనం మరియు రాత్రి భోజన వంటకాలను క్షణాల్లో కనుగొనండి!",
    "simSidebarCardBtn": "45+ వంటకాలను చూడండి",
    "simWelcomeText": "🙏 <b>స్వాగతం! నేను మీ మైమెనూబడ్డీ AI కిచెన్ అసిస్టెంట్!</b> 👩‍🍳\n\nఈరోజు ఏం వండాలి, కుటుంబ సభ్యుల సంఖ్యకు తగ్గ కొలతలు ఎలా మార్చాలి మరియు మీ కిచెన్‌లోని వస్తువులతో ఎలా వండాలి అనేదానికి నేను సహాయం చేస్తాను.\n\n✨ <b>నా సహాయాలు:</b>\n• 👩‍🍳 <b>ఈరోజు ఏం వండాలి?:</b> అల్పాహారం, మధ్యాహ్నం, రాత్రి భోజనానికి తక్షణ ఆలోచనలు\n• ⚖️ <b>స్మార్ట్ కొలతలు:</b> 1 నుండి 8+ వ్యక్తులకు సరిపడా ఆటోమేటిక్ కొలతల మార్పు\n• 🥬 <b>ప్యాంట్రీ వంట:</b> ఇంట్లో ఉన్న వస్తువులతో రుచికరమైన వంటలు\n• 🔍 <b>45+ సాంప్రదాయ రెసిపీలు:</b> తెలుగులో స్టెప్-బై-స్టెప్ తయారీ విధానం\n• 📅 <b>7 రోజుల భోజన ప్రణాళిక:</b> ఆరోగ్యకరమైన వారం మెనూ & కిరాణా లిస్ట్\n\nకింది బటన్ నొక్కండి లేదా మీ ప్రశ్నను అడగండి!",
    "simWelcomeButtons": [
      [
        {
          "text": "👩‍🍳 ఈరోజు ఏం వండాలి?",
          "action": "cmd_cook"
        },
        {
          "text": "🔍 రెసిపీలు శోధించండి",
          "action": "cmd_find"
        }
      ],
      [
        {
          "text": "🥬 నా కిచెన్ ప్యాంట్రీ",
          "action": "cmd_pantry"
        },
        {
          "text": "📅 7 రోజుల ప్లాన్",
          "action": "cmd_plan"
        }
      ],
      [
        {
          "text": "⚙️ ప్రొఫైల్ సెట్టింగ్స్",
          "action": "cmd_start"
        }
      ]
    ],
    "recipeTitle": "సాంప్రదాయ ప్రాంతీయ వంటకాల సమాహారం",
    "recipeSubtitle": "తమిళనాడు, కేరళ, ఆంధ్ర, ఉత్తర భారతదేశం మరియు అంతర్జాతీయ వంటకాలను కుటుంబ పరిమాణ కొలతలతో అన్వేషించండి.",
    "searchPlaceholder": "వంటకం పేరు, పదార్థం శోధించండి (ఉదా. బిర్యానీ, పనీర్, దోశ, పప్పు)...",
    "filterAllDiets": "అన్ని వంటకాలు",
    "filterVeg": "🥦 శాకాహారం",
    "filterNonVeg": "🍗 మాంసాహారం",
    "filterVegan": "🌱 వేగన్",
    "filterJain": "🧘 జైన్",
    "filterAllTimings": "అన్ని సమయాలు",
    "filterBreakfast": "🥞 అల్పాహారం",
    "filterLunch": "🍛 మధ్యాహ్నం భోజనం",
    "filterDinner": "🥘 రాత్రి భోజనం",
    "filterSnack": "☕ స్నాక్స్",
    "filterQuick": "⚡ < 20 నిమిషాలు",
    "regionAll": "📍 అన్ని 5 రాష్ట్రాలు (150 వంటకాలు)",
    "regionTN": "🌴 తమిళనాడు (30)",
    "regionKerala": "🥥 కేరళ (30)",
    "regionKarnataka": "🌾 కర్ణాటక (30)",
    "regionAndhra": "🌶️ ఆంధ్ర ప్రదేశ్ (30)",
    "regionTelangana": "🏛️ తెలంగాణ (30)",
    "recipesSearching": "రుచికరమైన వంటకాలను శోధిస్తోంది...",
    "recipesFound": "వంటకాలు లభించాయి",
    "emptyRecipesTitle": "సరిపోలే వంటకాలు లభించలేదు",
    "emptyRecipesDesc": "ఫిల్టర్లు తొలగించి చూడండి లేదా 'దోశ', 'బిర్యానీ', 'పనీర్', 'సాంబార్' వంటి పేర్లతో వెతకండి.",
    "cardVegBadge": "🥦 వెజ్",
    "cardNonVegBadge": "🍗 నాన్-వెజ్",
    "cardMins": "నిమిషాలు",
    "cardKeyIngs": "ముఖ్య పదార్థాలు:",
    "cardScales": "👨‍👩‍👧 1-8+ వ్యక్తుల కొలతలు",
    "cardEasy": "⚡ సులభం",
    "btnRecipeAndPortions": "రెసిపీ & కొలతలు",
    "btnAskChef": "💬 AI ని అడగండి",
    "btnAskChefTitle": "ఈ వంటకం గురించి AI అసిస్టెంట్‌ను అడగండి",
    "modalPortionLabel": "⚖️ కొలతల స్కేలర్ (ఎంతమంది వ్యక్తులకు):",
    "modalPortion1to2": "👤 1-2 వ్యక్తులు (0.5x)",
    "modalPortion3to4": "👨‍👩‍👧 3-4 వ్యక్తులు (1x)",
    "modalPortion5to6": "👨‍👩‍👧‍👦 5-6 వ్యక్తులు (1.5x)",
    "modalPortion8plus": "🎉 8+ విందు (2x)",
    "modalTabSummary": "📋 కావలసిన పదార్థాలు & త్వరిత విధానం",
    "modalTabMasterclass": "👩‍🍳 మాస్టర్‌క్లాస్ గైడెడ్ విధానం",
    "modalPart": "భాగం",
    "modalReqIngredients": "🛒 కావలసిన పదార్థాలు ({headcount} వ్యక్తులకు):",
    "modalQuickMethod": "⚡ త్వరిత తయారీ విధానం:",
    "modalMasterclassBanner": "👩‍🍳 <b>మాస్టర్‌క్లాస్ మోడ్:</b> ప్రతి దశను పూర్తి చేసిన తర్వాత టిక్ చేయండి. కింద ఉన్న టైమర్‌ను ఉపయోగించండి!",
    "modalStep": "దశ",
    "modalTimerLabel": "⏱ కుకింగ్ టైమర్:",
    "modalTimerStart": "ప్రారంభించు",
    "modalTimerPause": "పాజ్ చేయి",
    "modalTimerReset": "రీసెట్",
    "modalBtnCopy": "📋 రెసిపీ కాపీ చేయి",
    "modalBtnAskAI": "💬 AI ని అడగండి",
    "modalCopyAlert": "✅ రెసిపీ మరియు కొలతలు క్లిప్‌బోర్డ్‌కు కాపీ చేయబడ్డాయి!",
    "modalCookingTime": "వండే సమయం:",
    "modalRegion": "ప్రాంతం:",
    "modalPeople": "వ్యక్తులు",
    "pantryTitle": "స్మార్ట్ ప్యాంట్రీ చెఫ్: ఉన్న వస్తువులతో వండండి",
    "pantrySubtitle": "మీ కిచెన్‌లో ప్రస్తుతం అందుబాటులో ఉన్న పదార్థాలను ఎంచుకోండి. సరిపోయే పర్ఫెక్ట్ రెసిపీలను అమ్మనెక్స్ట్ వెతికి ఇస్తుంది!",
    "pantryInputPlaceholder": "పదార్థం పేరు టైప్ చేసి Enter నొక్కండి (ఉదా. పనీర్, చికెన్, క్యాప్సికమ్)...",
    "pantryBtnAdd": "పదార్థం జోడించు",
    "pantryBtnDefaults": "సాధారణ వస్తువులు",
    "pantryBtnClear": "అన్నీ క్లియర్ చేయి",
    "pantryTapToggle": "💡 ఏదైనా పాపులర్ వస్తువుపై ట్యాప్ చేయండి:",
    "pantryInventoryHeading": "🥬 మీ కిచెన్ ప్యాంట్రీ నిల్వలు:",
    "pantryInBasket": "ప్యాంట్రీలోని వస్తువులు ({count})",
    "pantryItemsCount": "వస్తువులు",
    "pantryEmptyInventory": "ఇంకా పదార్థాలు ఎంచుకోలేదు. పైన ఉన్న వస్తువులపై క్లిక్ చేయండి!",
    "pantryResultsHeading": "✨ మీ ప్యాంట్రీతో మీరు వండగల వంటకాలు:",
    "pantryCalculating": "సరిపోయే వంటకాలను లెక్కిస్తోంది...",
    "pantryEmptyMatches": "ఇప్పుడు ఏం వండవచ్చో తెలుసుకోవడానికి పైన పదార్థాలను జోడించండి!",
    "pantryMatchScore": "సరిపోలిక",
    "pantryAllIngsReady": "✅ మీ దగ్గర అన్ని ముఖ్య పదార్థాలు ఉన్నాయి!",
    "pantryNeed": "ఇంకా కావాల్సినవి: ",
    "pantryMore": "వస్తువులు",
    "pantryBtnCookThis": "ఇది వండండి",
    "plannerTitle": "7 రోజుల AI భోజన ప్రణాళిక",
    "plannerSubtitle": "ఆటోమేటిక్ కిరాణా లిస్ట్‌తో మీ కుటుంబానికి సరిపడే సమతుల్య, ఆరోగ్యకరమైన వారపు మెనూ.",
    "plannerPresetTamil": "🌴 దక్షిణ భారత సాంప్రదాయం",
    "plannerPresetHealthy": "🥗 హై ప్రోటీన్ & హెల్తీ ఫైబర్",
    "plannerBtnCopy": "📋 వారపు కిరాణా లిస్ట్ కాపీ చేయి",
    "plannerCopiedAlert": "📋 7 రోజుల ప్లాన్ & కిరాణా లిస్ట్ కాపీ అయ్యింది!",
    "plannerDays": {
      "Monday": "సోమవారం",
      "Tuesday": "మంగళవారం",
      "Wednesday": "బుధవారం",
      "Thursday": "గురువారం",
      "Friday": "శుక్రవారం",
      "Saturday": "శనివారం",
      "Sunday": "ఆదివారం"
    },
    "plannerSlots": {
      "b": "🥞 అల్పాహారం",
      "l": "🍛 మధ్యాహ్నం భోజనం",
      "s": "☕ సాయంత్రం స్నాక్స్",
      "d": "🥘 రాత్రి భోజనం"
    },
    "footerDesc": "మైమెనూబడ్డీ — గృహిణులు మరియు కుటుంబాల కోసం రూపొందించిన AI వంటల మార్గదర్శి. React & Node.js తో నిర్మితం.",
    "footerCol1Title": "త్వరిత నావిగేషన్",
    "footerCol2Title": "AI ఫీచర్లు",
    "footerCol3Title": "ప్రాంతీయ రుచులు",
    "fHome": "హోమ్ ఓవర్‌వ్యూ",
    "fAssistant": "AI కిచెన్ అసిస్టెంట్",
    "fRecipes": "45+ రెసిపీ ఎక్స్‌ప్లోరర్",
    "fPantry": "స్మార్ట్ ప్యాంట్రీ చెఫ్",
    "fPlanner": "7 రోజుల మీల్ ప్లానర్",
    "fCookToday": "ఈరోజు ఏం వండాలి?",
    "fPortionScaler": "1 నుండి 8+ కొలతల స్కేలర్",
    "fPantryMatcher": "కిచెన్ ప్యాంట్రీ మ్యాచర్",
    "fMasterclass": "మాస్టర్‌క్లాస్ గైడెడ్ మోడ్",
    "fGroceryList": "ఆటోమేటిక్ కిరాణా లిస్ట్",
    "fTamilNadu": "తమిళనాడు సాంప్రదాయం",
    "fKerala": "కేరళ స్పెషల్స్",
    "fAndhra": "ఆంధ్ర & తెలంగాణ ఘాటు",
    "fNorthIndian": "ఉత్తర భారత & పంజాబీ",
    "fGlobal": "ఇండో-చైనీస్ & గ్లోబల్",
    "fCopyright": "© 2026 మైమెనూబడ్డీ. సర్వ హక్కులు ప్రత్యేకించబడ్డాయి.",
    "fBadge": "React + Node.js ఫుల్-స్టాక్ యాప్",
    "fBackToTop": "పైకి వెళ్ళండి ↑",
    "btnFullscreen": "ఫుల్ స్క్రీన్",
    "btnExitFullscreen": "ఫుల్ స్క్రీన్ నిష్క్రమించు",
    "settingsTitle": "సెట్టింగ్స్ & భాష",
    "settingsLanguage": "భాషను ఎంచుకోండి",
    "settingsLanguageDesc": "తెలుగు, தமிழ், हिंदी, العربية లేదా English లోకి మార్చండి",
    "settingsDiet": "ఆహార ప్రాధాన్యత",
    "settingsServings": "కుటుంబ సభ్యుల సంఖ్య",
    "settingsClose": "సెట్టింగ్స్ మూసివేయి"
  },
  "Arabic": {
    "siteTitle": "ماي منيو بودي — الذكاء الاصطناعي للطبخ المنزلي",
    "siteTagline": "المساعد الذكي الأول لكل مطبخ ومنزل",
    "navHome": "الرئيسية",
    "navSimulator": "مساعد المطبخ الذكي",
    "navRecipes": "مستكشف الوصفات",
    "navTiffin": "صندوق الغداء",
    "navPantry": "شيف المؤونة الذكي",
    "navPlanner": "جدول الوجبات الأسبوعي",
    "navCommunity": "مجتمع الطهاة",
    "heroTitle": "لا تسأل <span>'ماذا نطبخ اليوم؟'</span> بعد الآن أبداً.",
    "heroSubtitle": "ماي منيو بودي هو مساعدك الذكي في المطبخ، يتذكر محتويات مؤونتك ويعدل مقادير الوصفات حسب عدد أفراد أسرتك ويوجهك باللغات العربية والتاميلية والهندية والإنجليزية.",
    "btnTrySimulator": "تحدث مع الشيف الذكي",
    "btnExploreRecipes": "استكشف أكثر من 45 وصفة",
    "statRecipes": "وصفات أصيلة معتمدة",
    "statStates": "مطابخ إقليمية متنوعة",
    "statLanguages": "5 لغات (العربية / தமிழ் / हिंदी / తెలుగు / EN)",
    "statPortions": "تعديل ديناميكي للكميات",
    "simTitle": "مساعد المطبخ التفاعلي الذكي",
    "simSubtitle": "تحدث مع ماي منيو بودي لاختيار وجبتك اليومية، والعثور على ألذ الوصفات، وإدارة مكونات مطبخك بسهولة.",
    "simOnline": "المساعد الذكي • متصل الآن",
    "simInputPlaceholder": "اسأل ماذا تطبخ، أو ابحث عن وصفة، أو اكتب /start, /cook...",
    "simSendTooltip": "إرسال الرسالة",
    "simBotName": "مساعد ماي منيو بودي الذكي للطبخ",
    "simBotStatus": "نشط • متصل الآن",
    "simChipCook": "👩‍🍳 ماذا نطبخ اليوم؟",
    "simChipBiryani": "🍗 برياني دجاج",
    "simChipDosa": "🥞 دوسا بالسمن",
    "simChipPantry": "🥬 مؤونة مطبخي",
    "simChipPlan": "📅 جدول 7 أيام",
    "simChipSettings": "⚙️ الإعدادات",
    "simSidebarTitle": "💡 مميزات ماي منيو بودي الأساسية:",
    "simSidebarFeature1": "1. اقتراحات متجددة: لن تتكرر أطباقك اليومية أبداً؛ اقتراحات طازجة ومميزة في كل مرة.",
    "simSidebarFeature2": "2. دعم كامل للغات: مقادير وخطوات تفصيلية بالعربية، التاميلية، الهندية، التيلجو والإنجليزية.",
    "simSidebarFeature3": "3. تعديل ذكي للحصص: تحويل تلقائي لكميات المكونات لخدمة من شخص واحد حتى أكثر من 8 أشخاص.",
    "simSidebarFeature4": "4. الطبخ من المؤونة: أخبر الشيف بما يتوفر في ثلاجتك، وسيقترح عليك أطباقاً فورية مدهشة.",
    "simSidebarCardTitle": "✨ تجربة طهي مخصصة لك",
    "simSidebarCardDesc": "اكتشف أسرار أشهى المأكولات الهندية والعالمية للفطور والغداء والعشاء خلال ثوانٍ!",
    "simSidebarCardBtn": "استكشف 45+ وصفة",
    "simWelcomeText": "🙏 <b>أهلاً بك! أنا مساعد ماي منيو بودي الذكي للطبخ!</b> 👩‍🍳\n\nأنا هنا لأساعدك في اختيار وجباتك اليومية، وضبط مقادير المكونات حسب عدد أفراد أسرتك، والطبخ بما يتوفر في مطبخك.\n\n✨ <b>كيف يمكنني مساعدتك:</b>\n• 👩‍🍳 <b>ماذا نطبخ اليوم؟:</b> أفكار فورية ملهمة للفطور والغداء والعشاء\n• ⚖️ <b>ميزان الحصص الذكي:</b> تحويل مقادير الطبخ التلقائي لـ 1 حتى 8+ أشخاص\n• 🥬 <b>الطبخ من المؤونة:</b> ابتكار أطباق شهية من المكونات المتوفرة لديك\n• 🔍 <b>45+ وصفة أصيلة:</b> خطوات مفصلة باللغة العربية\n• 📅 <b>جدول الوجبات لـ 7 أيام:</b> نظام غذائي متوازن مع قائمة التسوق\n\nاضغط على أي زر أدناه أو اطرح سؤالك في أي وقت!",
    "simWelcomeButtons": [
      [
        {
          "text": "👩‍🍳 ماذا نطبخ اليوم؟",
          "action": "cmd_cook"
        },
        {
          "text": "🔍 البحث في الوصفات",
          "action": "cmd_find"
        }
      ],
      [
        {
          "text": "🥬 مؤونة المطبخ",
          "action": "cmd_pantry"
        },
        {
          "text": "📅 جدول الوجبات 7 أيام",
          "action": "cmd_plan"
        }
      ],
      [
        {
          "text": "⚙️ إعدادات الحساب",
          "action": "cmd_start"
        }
      ]
    ],
    "recipeTitle": "موسوعة الوصفات الإقليمية الأصيلة",
    "recipeSubtitle": "استكشف وصفات تاميل نادو، كيرلا، أندرا، شمال الهند والمطابخ العالمية مع ميزة تعديل المقادير الذكي.",
    "searchPlaceholder": "ابحث باسم الطبق أو المكون (مثل: برياني، دوسا، بانير، دجاج)...",
    "filterAllDiets": "جميع الوصفات",
    "filterVeg": "🥦 نباتي",
    "filterNonVeg": "🍗 غير نباتي",
    "filterVegan": "🌱 نباتي صرف",
    "filterJain": "🧘 جاين",
    "filterAllTimings": "جميع الأوقات",
    "filterBreakfast": "🥞 إفطار",
    "filterLunch": "🍛 غداء",
    "filterDinner": "🥘 عشاء",
    "filterSnack": "☕ وجبات خفيفة",
    "filterQuick": "⚡ سريع (< 20 دقيقة)",
    "regionAll": "📍 جميع المناطق الـ 5 (150 طبق)",
    "regionTN": "🌴 تاميل نادو (30)",
    "regionKerala": "🥥 كيرلا (30)",
    "regionKarnataka": "🌾 كارناتاكا (30)",
    "regionAndhra": "🌶️ أندرا براديش (30)",
    "regionTelangana": "🏛️ تيلانجانا (30)",
    "recipesSearching": "جاري البحث في الوصفات الأصيلة...",
    "recipesFound": "أطباق تم العثور عليها",
    "emptyRecipesTitle": "لم يتم العثور على أطباق مطابقة",
    "emptyRecipesDesc": "جرب إزالة الفلاتر أو ابحث بكلمات مشهورة مثل 'دوسا', 'برياني', 'بانير', 'سامبار'.",
    "cardVegBadge": "🥦 نباتي",
    "cardNonVegBadge": "🍗 غير نباتي",
    "cardMins": "دقيقة",
    "cardKeyIngs": "المكونات الأساسية:",
    "cardScales": "👨‍👩‍👧 يعدل لـ 1-8+ أشخاص",
    "cardEasy": "⚡ سهل",
    "btnRecipeAndPortions": "الوصفة والمقادير",
    "btnAskChef": "💬 اسأل الذكاء الاصطناعي",
    "btnAskChefTitle": "اسأل الشيف الذكي عن هذا الطبق",
    "modalPortionLabel": "⚖️ ميزان الحصص (اختر عدد الأفراد للطبق):",
    "modalPortion1to2": "👤 1-2 أفراد (0.5x)",
    "modalPortion3to4": "👨‍👩‍👧 3-4 أفراد (1x)",
    "modalPortion5to6": "👨‍👩‍👧‍👦 5-6 أفراد (1.5x)",
    "modalPortion8plus": "🎉 8+ وليمة (2x)",
    "modalTabSummary": "📋 المكونات وطريقة التحضير السريعة",
    "modalTabMasterclass": "👩‍🍳 وضع التوجيه خطوة بخطوة",
    "modalPart": "الجزء",
    "modalReqIngredients": "🛒 المكونات المطلوبة (تكفي {headcount} أشخاص):",
    "modalQuickMethod": "⚡ طريقة التحضير السريعة:",
    "modalMasterclassBanner": "👩‍🍳 <b>وضع الطاهي المحترف:</b> ضع علامة صح بعد إنجاز كل خطوة، واستخدم مؤقت الطبخ أدناه!",
    "modalStep": "خطوة",
    "modalTimerLabel": "⏱ مؤقت الطبخ الذكي:",
    "modalTimerStart": "بدء",
    "modalTimerPause": "إيقاف مؤقت",
    "modalTimerReset": "إعادة ضبط",
    "modalBtnCopy": "📋 نسخ الوصفة",
    "modalBtnAskAI": "💬 اسأل الشيف الذكي",
    "modalCopyAlert": "✅ تم نسخ الوصفة والمقادير إلى الحافظة بنجاح!",
    "modalCookingTime": "وقت الطهي:",
    "modalRegion": "المنطقة:",
    "modalPeople": "أشخاص",
    "pantryTitle": "شيف المؤونة: اطبخ بما يتوفر في منزلك",
    "pantrySubtitle": "حدد المكونات المتوفرة في مطبخك الآن، وسيقوم ماي منيو بودي باقتراح ألذ الوصفات المتطابقة واحتساب النواقص بدقة!",
    "pantryInputPlaceholder": "اكتب اسم مكون (مثل: بانير، دجاج، طماطم) واضغط Enter...",
    "pantryBtnAdd": "إضافة مكون",
    "pantryBtnDefaults": "المكونات الشائعة",
    "pantryBtnClear": "مسح الكل",
    "pantryTapToggle": "💡 اضغط على أي مكون شائع لتحديده:",
    "pantryInventoryHeading": "🥬 محتويات مؤونة مطبخك الحالية:",
    "pantryInBasket": "عناصر في المؤونة ({count})",
    "pantryItemsCount": "مكونات",
    "pantryEmptyInventory": "لم تختر أي مكونات بعد. اضغط على أي من المكونات أعلاه!",
    "pantryResultsHeading": "✨ أطباق يمكنك طهيها بمكوناتك الحالية:",
    "pantryCalculating": "جاري مطابقة المكونات مع الوصفات...",
    "pantryEmptyMatches": "أضف مكوناتك أعلاه لاكتشاف ما يمكنك طبخه الآن فوراً!",
    "pantryMatchScore": "نسبة التطابق",
    "pantryAllIngsReady": "✅ يتوفر لديك جميع المكونات الأساسية!",
    "pantryNeed": "ينقصك: ",
    "pantryMore": "مكونات إضافية",
    "pantryBtnCookThis": "اطبخ هذا الطبق",
    "plannerTitle": "جدول الوجبات الأسبوعي بالذكاء الاصطناعي",
    "plannerSubtitle": "جداول وجبات أسبوعية صحية ومتوازنة مخصصة لعائلتك مع قائمة تسوق ذكية للمقاضي.",
    "plannerPresetTamil": "🌴 مطبخ جنوب الهند التقليدي",
    "plannerPresetHealthy": "🥗 بروتين عالي وألياف صحية",
    "plannerBtnCopy": "📋 نسخ قائمة المقاضي الأسبوعية",
    "plannerCopiedAlert": "📋 تم نسخ جدول الوجبات وقائمة المقاضي إلى الحافظة!",
    "plannerDays": {
      "Monday": "الإثنين",
      "Tuesday": "الثلاثاء",
      "Wednesday": "الأربعاء",
      "Thursday": "الخميس",
      "Friday": "الجمعة",
      "Saturday": "السبت",
      "Sunday": "الأحد"
    },
    "plannerSlots": {
      "b": "🥞 إفطار",
      "l": "🍛 غداء",
      "s": "☕ وجبة خفيفة",
      "d": "🥘 عشاء"
    },
    "footerDesc": "ماي منيو بودي — تمكين الأسر وهواة الطهي بالذكاء الاصطناعي للطبخ المنزلي. مبني بتقنيات React و Node.js.",
    "footerCol1Title": "روابط سريعة",
    "footerCol2Title": "مزايا الذكاء الاصطناعي",
    "footerCol3Title": "المطابخ الأصلية",
    "fHome": "نظرة عامة",
    "fAssistant": "مساعد المطبخ الذكي",
    "fRecipes": "مستكشف 45+ وصفة",
    "fPantry": "شيف المؤونة الذكي",
    "fPlanner": "جدول الوجبات 7 أيام",
    "fCookToday": "ماذا أطبخ اليوم؟",
    "fPortionScaler": "ميزان الحصص لـ 1 حتى 8+ أفراد",
    "fPantryMatcher": "مطابق مؤونة المطبخ",
    "fMasterclass": "وضع التوجيه خطوة بخطوة",
    "fGroceryList": "قائمة المقاضي التلقائية",
    "fTamilNadu": "مطبخ تاميل نادو الأصيل",
    "fKerala": "أطباق كيرلا المميزة",
    "fAndhra": "مطبخ أندرا الحار",
    "fNorthIndian": "شمال الهند والبنجاب",
    "fGlobal": "المطبخ العالمي والصيني",
    "fCopyright": "© 2026 ماي منيو بودي. جميع الحقوق محفوظة.",
    "fBadge": "تطبيق React + Node.js متكامل",
    "fBackToTop": "العودة للأعلى ↑",
    "btnFullscreen": "ملء الشاشة",
    "btnExitFullscreen": "الخروج من ملء الشاشة",
    "settingsTitle": "الإعدادات واللغة",
    "settingsLanguage": "اختر اللغة",
    "settingsLanguageDesc": "التبديل بين العربية، தமிழ்، हिंदी، తెలుగు والإنجليزية",
    "settingsDiet": "النظام الغذائي المفضل",
    "settingsServings": "عدد أفراد الأسرة الافتراضي",
    "settingsClose": "إغلاق الإعدادات"
  },
  "Kannada": {
    "siteTitle": "MyMenuBuddy — ಕುಟುಂಬದ ಆಹಾರ AI",
    "siteTagline": "ಪ್ರತಿಯೊಂದು ಮನೆಗೂ ಸ್ಮಾರ್ಟ್ AI ಅಡುಗೆ ಸಹಾಯಕ",
    "navHome": "ಮುಖಪುಟ",
    "navSimulator": "AI ಅಡುಗೆ ಸಹಾಯಕ",
    "navRecipes": "ರೆಸಿಪಿ ಅನ್ವೇಷಕ",
    "navTiffin": "ಟಿಫಿನ್ ಬಾಕ್ಸ್",
    "navPantry": "ಸ್ಮಾರ್ಟ್ ಕಿಚನ್ ಪ pantry",
    "navPlanner": "ವಾರದ ಊಟದ ಯೋಜನೆ",
    "navCommunity": "ಸಮುದಾಯ ಫೀಡ್",
    "heroTitle": "ಇನ್ನು ಮುಂದೆ <span>'ಇಂದು ಏನು ಅಡುಗೆ ಮಾಡುವುದು?'</span> ಎಂದು ಚಿಂತಿಸಬೇಡಿ.",
    "heroSubtitle": "MyMenuBuddy ನಿಮ್ಮ ವೈಯಕ್ತಿಕ AI ಅಡುಗೆ ಸಹಾಯಕ. ನಿಮ್ಮ ಸಾಮಗ್ರಿಗಳನ್ನು ನೆನಪಿಟ್ಟುಕೊಳ್ಳುತ್ತದೆ, ಕುಟುಂಬದ ಸದಸ್ಯರಿಗೆ ತಕ್ಕಂತೆ ಅಳತೆ ಮಾಡುತ್ತದೆ ಮತ್ತು 150+ ದಕ್ಷಿಣ ಭಾರತೀಯ ರೆಸಿಪಿಗಳನ್ನು ನೀಡುತ್ತದೆ.",
    "btnTrySimulator": "AI ಚೆಫ್ ಜೊತೆ ಮಾತನಾಡಿ",
    "btnExploreRecipes": "150+ ರೆಸಿಪಿಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",
    "statRecipes": "150 ದಕ್ಷಿಣ ಭಾರತೀಯ ರೆಸಿಪಿಗಳು",
    "statStates": "5 ದಕ್ಷಿಣ ಭಾರತೀಯ ರಾಜ್ಯಗಳು",
    "statLanguages": "ಕನ್ನಡ ಸೇರಿದಂತೆ ಬಹುಭಾಷೆ",
    "statPortions": "ಅಳತೆ ಮಾರ್ಪಾಡು",
    "simTitle": "ಇಂಟರ್ಯಾಕ್ಟಿವ್ AI ಕಿಚನ್ ಸಹಾಯಕ",
    "simSubtitle": "ಏನು ಅಡುಗೆ ಮಾಡಬೇಕೆಂದು ತಿಳಿಯಲು, ರೆಸಿಪಿಗಳನ್ನು ಹುಡುಕಲು MyMenuBuddy ಜೊತೆ ಚಾಟ್ ಮಾಡಿ.",
    "simOnline": "AI ಸಹಾಯಕ • ಆನ್‌ಲೈನ್",
    "simInputPlaceholder": "ಏನು ಅಡುಗೆ ಮಾಡಬೇಕೆಂದು ಕೇಳಿ, ಅಥವಾ /cook, /recipe ಟೈಪ್ ಮಾಡಿ...",
    "simSendTooltip": "ಸಂದೇಶ ಕಳುಹಿಸಿ",
    "simBotName": "MyMenuBuddy AI ಕಿಚನ್ ಸಹಾಯಕ",
    "simBotStatus": "ಸಕ್ರಿಯ • ಆನ್‌ಲೈನ್",
    "simChipCook": "👩‍🍳 ಇಂದು ಏನು ಅಡುಗೆ?",
    "simChipBiryani": "🍗 ಬಿರಿಯಾನಿ",
    "simChipDosa": "🥞 ಮಸಾಲೆ ದೋಸೆ",
    "simChipPantry": "🥬 ನನ್ನ ಸಾಮಗ್ರಿಗಳು",
    "simChipPlan": "📅 7 ದಿನಗಳ ಯೋಜನೆ",
    "searchPlaceholder": "ರೆಸಿಪಿಗಳು, ಪದಾರ್ಥಗಳು ಅಥವಾ ರಾಜ್ಯ ಹುಡುಕಿ...",
    "filterAllDiets": "ಎಲ್ಲಾ ಆಹಾರಗಳು",
    "filterVeg": "🥦 ಸಸ್ಯಾಹಾರಿ (Veg)",
    "filterNonVeg": "🍗 ಮಾಂಸಾಹಾರಿ (Non-Veg)",
    "filterVegan": "🌱 ಸಸ್ಯಾಹಾರಿ",
    "filterJain": "🕉 ಜೈನ",
    "filterAllTimings": "ಎಲ್ಲಾ ಸಮಯಗಳು",
    "filterBreakfast": "🥞 ತಿಂಡಿ / ಉಪಹಾರ",
    "filterLunch": "🍛 ಮಧ್ಯಾಹ್ನದ ಊಟ",
    "filterDinner": "🥘 ರಾತ್ರಿಯ ಊಟ",
    "filterSnack": "☕ ಸಂಜೆ ತಿಂಡಿ",
    "filterQuick": "⚡ < 20 ನಿಮಿಷಗಳು",
    "regionAll": "📍 ಎಲ್ಲಾ 5 ರಾಜ್ಯಗಳು (150 ಭಕ್ಷ್ಯಗಳು)",
    "regionTN": "🌴 ತಮಿಳುನಾಡು (30)",
    "regionKerala": "🥥 ಕೇರಳ (30)",
    "regionKarnataka": "🌾 ಕರ್ನಾಟಕ (30)",
    "regionAndhra": "🌶️ ಆಂಧ್ರ ಪ್ರದೇಶ (30)",
    "regionTelangana": "🏛️ ತೆಲಂಗಾಣ (30)",
    "recipesSearching": "ರುಚಿಕರವಾದ ಅಡುಗೆಗಳನ್ನು ಹುಡುಕಲಾಗುತ್ತಿದೆ...",
    "recipesFound": "ಭಕ್ಷ್ಯಗಳು ದೊರೆತಿವೆ",
    "emptyRecipesTitle": "ಯಾವುದೇ ಅಡುಗೆ ಸಿಗಲಿಲ್ಲ",
    "emptyRecipesDesc": "ಫಿಲ್ಟರ್ ಬದಲಾಯಿಸಿ ಅಥವಾ 'ದೋಸೆ', 'ಇಡ್ಲಿ', 'ರೈಸ್' ಎಂದು ಹುಡುಕಿ.",
    "cardVegBadge": "🥦 ಸಸ್ಯ",
    "cardNonVegBadge": "🍗 ಮಾಂಸ",
    "cardMins": "ನಿಮಿಷ",
    "cardKeyIngs": "ಮುಖ್ಯ ಸಾಮಗ್ರಿಗಳು:",
    "cardScales": "👨‍👩‍👧 1-8+ ಜನರಿಗೆ ಅಳತೆ",
    "cardEasy": "⚡ ಸುಲಭ",
    "btnRecipeAndPortions": "ವಿಧಾನ ಮತ್ತು ಅಳತೆ",
    "modalCookingTime": "ಅಡುಗೆ ಸಮಯ:",
    "modalRegion": "ಮೂಲ:",
    "modalDiet": "ಆಹಾರ ವಿಧ:",
    "modalServings": "ಪ್ರಮಾಣ:",
    "modalPortionScalerTitle": "ಜನರ ಸಂಖ್ಯೆಗೆ ತಕ್ಕಂತೆ ಅಳತೆ:",
    "modalScaleSubtitle": "ಕುಟುಂಬದ ಸದಸ್ಯರ ಸಂಖ್ಯೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "modalPersons": "ಜನರು",
    "modalIngredientsTitle": "ಬೇಕಾಗುವ ಸಾಮಗ್ರಿಗಳು",
    "modalStepByStepTitle": "ತಯಾರಿಸುವ ವಿಧಾನ (ಹಂತ-ಹಂತವಾಗಿ)",
    "modalOpenInBot": "Telegram Bot ನಲ್ಲಿ ವೀಕ್ಷಿಸಿ",
    "modalNutritionBadge": "ಪೌಷ್ಟಿಕ ಆಹಾರ",
    "modalPrepNotice": "ತಾಜಾ ಸಾಮಗ್ರಿಗಳೊಂದಿಗೆ ತಯಾರಿಸಿ",
    "pantryTitle": "ಸ್ಮಾರ್ಟ್ ಕಿಚನ್ ಪ pantry",
    "pantrySubtitle": "ಮನೆಯಲ್ಲಿರುವ ಸಾಮಗ್ರಿಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ, ತಕ್ಷಣ ಅಡುಗೆ ಸಲಹೆ ಪಡೆಯಿರಿ.",
    "plannerTitle": "7 ದಿನಗಳ ಊಟದ ಯೋಜನೆ",
    "plannerSubtitle": "ಆರೋಗ್ಯಕರ ಮತ್ತು ಸಮತೋಲಿತ ವಾರದ ಊಟದ ವೇಳಾಪಟ್ಟಿ.",
    "fHome": "ಮುಖಪುಟ",
    "fAssistant": "AI ಸಹಾಯಕ",
    "fRecipes": "150 ರೆಸಿಪಿಗಳು",
    "fPantry": "ಕಿಚನ್ ಪ pantry",
    "fPlanner": "ವಾರದ ಯೋಜನೆ",
    "fCookToday": "ಇಂದು ಏನು ಅಡುಗೆ?",
    "fPortionScaler": "ಅಳತೆ ಮಾಪಕ",
    "fPantryMatcher": "ಸಾಮಗ್ರಿ ಮ್ಯಾಚರ್",
    "fMasterclass": "ಹಂತ-ಹಂತದ ವಿಧಾನ",
    "fGroceryList": "ಖರೀದಿ ಪಟ್ಟಿ",
    "fTamilNadu": "ತಮಿಳುನಾಡು ಶೈಲಿ",
    "fKerala": "ಕೇರಳ ಶೈಲಿ",
    "fAndhra": "ಆಂಧ್ರ ಶೈಲಿ",
    "fNorthIndian": "ಕರ್ನಾಟಕ ಶೈಲಿ",
    "fGlobal": "ತೆಲಂಗಾಣ ಶೈಲಿ",
    "fCopyright": "© 2026 MyMenuBuddy. ಸರ್ವ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
    "fBadge": "ಪೂರ್ಣ React + Node.js ಆಪ್",
    "fBackToTop": "ಮೇಲಕ್ಕೆ ಹೋಗಿ ↑",
    "btnFullscreen": "ಪೂರ್ಣ ಪರದೆ",
    "btnExitFullscreen": "ಸಾಮಾನ್ಯ ಪರದೆ",
    "settingsTitle": "ಸೆಟ್ಟಿಂಗ್ಸ್ & ಭಾಷೆ",
    "settingsLanguage": "ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ",
    "settingsLanguageDesc": "ಕನ್ನಡ, தமிழ், മലയാളം, తెలుగు, हिंदी ಮತ್ತು ಇಂಗ್ಲಿಷ್ ನಡುವೆ ಬದಲಾಯಿಸಿ",
    "settingsDiet": "ಆಹಾರ ಆದ್ಯತೆ",
    "settingsServings": "ಕುಟುಂಬದ ಸದಸ್ಯರು",
    "settingsClose": "ಮುಚ್ಚಿ",
    "simChipSettings": "⚙️ ಸೆಟ್ಟಿಂಗ್ಸ್",
    "simSidebarTitle": "💡 MyMenuBuddy ಪ್ರಮುಖ ವೈಶಿಷ್ಟ್ಯಗಳು:",
    "simSidebarFeature1": "1. ತಾಜಾ ಶಿಫಾರಸುಗಳು: ಪುನರಾವರ್ತಿತ ಖಾದ್ಯಗಳಿಲ್ಲದೆ ಪ್ರತಿ ಬಾರಿಯೂ ತಾಜಾ ತಿನಿಸುಗಳು.",
    "simSidebarFeature2": "2. ಬಹುಭಾಷಾ ಬೆಂಬಲ: ಸಾಮಗ್ರಿಗಳು, ಪ್ರಮಾಣ ಮತ್ತು ವಿಧಾನಗಳು ಕನ್ನಡದಲ್ಲಿ ಲಭ್ಯ.",
    "simSidebarFeature3": "3. ಡೈನಾಮಿಕ್ ಪ್ರಮಾಣ ಸ್ಕೇಲರ್: 1 ರಿಂದ 8+ ಜನರಿಗೆ ತಕ್ಕಂತೆ ಸ್ವಯಂಚಾಲಿತ ಅಳತೆ.",
    "simSidebarFeature4": "4. ಪ್ಯಾಂಟ್ರಿ ಅಡುಗೆ: ನಿಮ್ಮಲ್ಲಿರುವ ಸಾಮಗ್ರಿಗಳಿಂದಲೇ ತಕ್ಷಣ ಮಾಡಬಹುದಾದ ತಿನಿಸುಗಳು.",
    "simSidebarCardTitle": "✨ ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ ಅಡುಗೆ",
    "simSidebarCardDesc": "ದಕ್ಷಿಣ ಮತ್ತು ಉತ್ತರ ಭಾರತೀಯ ಅಡುಗೆಗಳನ್ನು ಕ್ಷಣಾರ್ಧದಲ್ಲಿ ಅನ್ವೇಷಿಸಿ!",
    "simSidebarCardBtn": "150+ ರೆಸಿಪಿಗಳನ್ನು ನೋಡಿ",
    "simWelcomeText": "🙏 <b>ಸ್ವಾಗತ! ನಾನು MyMenuBuddy AI ಅಡುಗೆ ಸಹಾಯಕ!</b> 👩‍🍳\n\nಇಂದು ಏನು ಮಾಡಬೇಕೆಂದು ನಿರ್ಧರಿಸಲು, ಜನರ ಸಂಖ್ಯೆಗೆ ತಕ್ಕಂತೆ ಸಾಮಗ್ರಿಗಳನ್ನು ಅಳೆಯಲು ಮತ್ತು ಮನೆಯಲ್ಲಿರುವ ವಸ್ತುಗಳಿಂದ ಅಡುಗೆ ಮಾಡಲು ನಾನು ನಿಮಗೆ ಸಹಾಯ ಮಾಡುತ್ತೇನೆ.\n\n✨ <b>ನನ್ನ ಸೇವೆಗಳು:</b>\n• 👩‍🍳 <b>ಇಂದು ಏನು ಅಡುಗೆ?:</b> ಉಪಾಹಾರ, ಮಧ್ಯಾಹ್ನ ಮತ್ತು ರಾತ್ರಿಯ ಊಟಕ್ಕೆ ಸಲಹೆಗಳು\n• ⚖️ <b>ಸ್ಮಾರ್ಟ್ ಪ್ರಮಾಣ ಸ್ಕೇಲರ್:</b> 1 ರಿಂದ 8+ ಜನರಿಗೆ ಸ್ವಯಂಚಾಲಿತ ಅಳತೆಗಳು\n• 🥬 <b>ಮನೆಯ ಸಾಮಗ್ರಿಗಳ ಅಡುಗೆ:</b> ಅಡುಗೆಮನೆಯಲ್ಲಿರುವ ವಸ್ತುಗಳಿಂದಲೇ ರುಚಿಕರ ಅಡುಗೆ\n• 🔍 <b>150+ ಸಾಂಪ್ರದಾಯಿಕ ರೆಸಿಪಿಗಳು:</b> ಸರಳ ಹಂತ-ಹಂತದ ವಿಧಾನಗಳು\n• 📅 <b>7-ದಿನಗಳ ಊಟದ ಯೋಜನೆ:</b> ಸಮತೋಲಿತ ವಾರದ ಅಡುಗೆ ಪಟ್ಟಿ\n\nಕೆಳಗಿನ ಬಟನ್ ಒತ್ತಿ ಅಥವಾ ಯಾವುದೇ ಅಡುಗೆ ಪ್ರಶ್ನೆಯನ್ನು ಕೇಳಿ!",
    "simWelcomeButtons": [
      [
        {
          "text": "👩‍🍳 ಇಂದು ಏನು ಅಡುಗೆ?",
          "action": "cmd_cook"
        },
        {
          "text": "🔍 ರೆಸಿಪಿ ಹುಡುಕಿ",
          "action": "cmd_find"
        }
      ],
      [
        {
          "text": "🥬 ನನ್ನ ಅಡುಗೆ ಸಾಮಗ್ರಿಗಳು",
          "action": "cmd_pantry"
        },
        {
          "text": "📅 7-ದಿನಗಳ ಯೋಜನೆ",
          "action": "cmd_plan"
        }
      ],
      [
        {
          "text": "⚙️ ಪ್ರೊಫೈಲ್ ಸೆಟ್ಟಿಂಗ್ಸ್",
          "action": "cmd_start"
        }
      ]
    ],
    "recipeTitle": "ಸಾಂಪ್ರದಾಯಿಕ ಪ್ರಾದೇಶಿಕ ಪಾಕವಿಧಾನಗಳ ಸಂಗ್ರಹ",
    "recipeSubtitle": "ಕರ್ನಾಟಕ, ತಮಿಳುನಾಡು, ಕೇರಳ, ಆಂಧ್ರ ಮತ್ತು ತೆಲಂಗಾಣದ 150 ಕ್ಕೂ ಹೆಚ್ಚು ತಿನಿಸುಗಳನ್ನು ಜನರ ಸಂಖ್ಯೆಗೆ ತಕ್ಕಂತೆ ಅಳತೆಗಳೊಂದಿಗೆ ತಯಾರಿಸಿ.",
    "btnAskChef": "💬 AI ಗೆ ಕೇಳಿ",
    "btnAskChefTitle": "AI ಅಡುಗೆ ಸಹಾಯಕರ ಬಳಿ ಈ ಖಾದ್ಯದ ಬಗ್ಗೆ ಕೇಳಿ",
    "modalPortionLabel": "⚖️ ಆಹಾರ ಪ್ರಮಾಣ ಮಾಪಕ (ಜನರ ಸಂಖ್ಯೆ):",
    "modalPortion1to2": "👤 1-2 ಜನರು (0.5x)",
    "modalPortion3to4": "👨‍👩‍👧 3-4 ಜನರು (1x)",
    "modalPortion5to6": "👨‍👩‍👧‍👦 5-6 ಜನರು (1.5x)",
    "modalPortion8plus": "🎉 8+ ಔತಣ (2x)",
    "modalTabSummary": "📋 ಸಾಮಗ್ರಿಗಳು ಮತ್ತು ತ್ವರಿತ ವಿಧಾನ",
    "modalTabMasterclass": "👩‍🍳 ಮಾಸ್ಟರ್‌ಕ್ಲಾಸ್ ಮಾರ್ಗದರ್ಶಿ",
    "modalPart": "ಭಾಗ",
    "modalReqIngredients": "🛒 ಬೇಕಾಗುವ ಸಾಮಗ್ರಿಗಳು ({headcount} ಜನರಿಗೆ):",
    "modalQuickMethod": "⚡ ತ್ವರಿತ ವಿಧಾನ:",
    "modalMasterclassBanner": "👩‍🍳 <b>ಮಾಸ್ಟರ್‌ಕ್ಲಾಸ್ ಮೋಡ್:</b> ಪ್ರತಿ ಹಂತವನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ ಟಿಕ್ ಮಾಡಿ. ಅಡುಗೆ ಟೈಮರ್ ಬಳಸಿ!",
    "modalStep": "ಹಂತ",
    "modalTimerLabel": "⏱ ಅಡುಗೆ ಟೈಮರ್:",
    "modalTimerStart": "ಪ್ರಾರಂಭಿಸಿ",
    "modalTimerPause": "ವಿರಾಮ",
    "modalTimerReset": "ಮರುಹೊಂದಿಸಿ",
    "modalBtnCopy": "📋 ರೆಸಿಪಿ ಕಾಪಿ ಮಾಡಿ",
    "modalBtnAskAI": "💬 AI ಗೆ ಕೇಳಿ",
    "modalCopyAlert": "✅ ರೆಸಿಪಿ ಮತ್ತು ಅಳತೆಗಳನ್ನು ಕಾಪಿ ಮಾಡಲಾಗಿದೆ!",
    "modalPeople": "ಜನರು",
    "pantryInputPlaceholder": "ಸಾಮಗ್ರಿಯ ಹೆಸರನ್ನು ಟೈಪ್ ಮಾಡಿ Enter ಒತ್ತಿ (ಉದಾ: ಪನ್ನೀರ್, ಚಿಕನ್, ಆಲೂಗಡ್ಡೆ)...",
    "pantryBtnAdd": "ಸಾಮಗ್ರಿ ಸೇರಿಸಿ",
    "pantryBtnDefaults": "ಸಾಮಾನ್ಯವಾದವು",
    "pantryBtnClear": "ಎಲ್ಲವನ್ನೂ ತೆರವುಗೊಳಿಸಿ",
    "pantryTapToggle": "💡 ತ್ವರಿತವಾಗಿ ಸೇರಿಸಲು ಯಾವುದಾದರೂ ಸಾಮಗ್ರಿಯನ್ನು ಟ್ಯಾಪ್ ಮಾಡಿ:",
    "pantryInventoryHeading": "🥬 ನಿಮ್ಮ ಅಡುಗೆಮನೆಯ ಸಂಗ್ರಹ ಪಟ್ಟಿ:",
    "pantryInBasket": "ಅಡುಗೆಮನೆಯಲ್ಲಿರುವ ಸಾಮಗ್ರಿಗಳು ({count})",
    "pantryItemsCount": "ಸಾಮಗ್ರಿಗಳು",
    "pantryEmptyInventory": "ಯಾವುದೇ ಸಾಮಗ್ರಿಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿಲ್ಲ. ಮೇಲಿನವುಗಳನ್ನು ಒತ್ತಿ!",
    "pantryResultsHeading": "✨ ನಿಮ್ಮ ಸಾಮಗ್ರಿಗಳಿಂದ ಮಾಡಬಹುದಾದ ತಿನಿಸುಗಳು:",
    "pantryCalculating": "ಹೊಂದಾಣಿಕೆಯಾಗುವ ತಿನಿಸುಗಳನ್ನು ಲೆಕ್ಕಾಚಾರ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "pantryEmptyMatches": "ಈಗ ಮಾಡಬಹುದಾದ ಖಾದ್ಯಗಳನ್ನು ತಿಳಿಯಲು ಮೇಲೆ ಸಾಮಗ್ರಿಗಳನ್ನು ಸೇರಿಸಿ!",
    "pantryMatchScore": "ಹೊಂದಾಣಿಕೆ",
    "pantryAllIngsReady": "✅ ಎಲ್ಲಾ ಮುಖ್ಯ ಸಾಮಗ್ರಿಗಳು ನಿಮ್ಮಲ್ಲಿವೆ!",
    "pantryNeed": "ಬೇಕಾಗಿರುವುದು: ",
    "pantryMore": "ಹೆಚ್ಚು",
    "pantryBtnCookThis": "ತಯಾರಿಸಿ",
    "plannerPresetTamil": "🌴 ದಕ್ಷಿಣ ಭಾರತ ಸಾಂಪ್ರದಾಯಿಕ",
    "plannerPresetHealthy": "🥗 ಆರೋಗ್ಯಕರ ಹೈ ಪ್ರೋಟೀನ್",
    "plannerBtnCopy": "📋 ವಾರದ ದಿನಸಿ ಪಟ್ಟಿಯನ್ನು ಕಾಪಿ ಮಾಡಿ",
    "plannerCopiedAlert": "📋 7-ದಿನಗಳ ಯೋಜನೆ & ದಿನಸಿ ಪಟ್ಟಿಯನ್ನು ಕಾಪಿ ಮಾಡಲಾಗಿದೆ!",
    "plannerDays": {
      "Monday": "ಸೋಮವಾರ",
      "Tuesday": "ಮಂಗಳವಾರ",
      "Wednesday": "ಬುಧವಾರ",
      "Thursday": "ಗುರುವಾರ",
      "Friday": "ಶುಕ್ರವಾರ",
      "Saturday": "ಶನಿವಾರ",
      "Sunday": "ಭಾನುವಾರ"
    },
    "plannerSlots": {
      "b": "🥞 ಉಪಾಹಾರ",
      "l": "🍛 ಮಧ್ಯಾಹ್ನದ ಊಟ",
      "s": "☕ ಸಂಜೆಯ ತಿಂಡಿ",
      "d": "🥘 ರಾತ್ರಿಯ ಊಟ"
    },
    "footerDesc": "MyMenuBuddy — ಕುಟುಂಬಗಳ ದೈನಂದಿನ ಅಡುಗೆಯನ್ನು ಸುಲಭಗೊಳಿಸುವ AI ಆಧಾರಿತ ತಾಣ.",
    "footerCol1Title": "ತ್ವರಿತ ಲಿಂಕ್‌ಗಳು",
    "footerCol2Title": "AI ವೈಶಿಷ್ಟ್ಯಗಳು",
    "footerCol3Title": "ಪ್ರಾದೇಶಿಕ ಆಹಾರಗಳು"
  },
  "Malayalam": {
    "siteTitle": "MyMenuBuddy — കുടുംബ ഫുഡ് AI",
    "siteTagline": "ഓരോ വീടിനും സ്മാർട്ട് AI പാചക സഹായി",
    "navHome": "ഹോം",
    "navSimulator": "AI കിച്ചൻ അസിസ്റ്റന്റ്",
    "navRecipes": "റെസിപ്പി എക്സ്പ്ലോറർ",
    "navTiffin": "ടിഫിൻ ബോക്സ്",
    "navPantry": "സ്മാർട്ട് പാൻട്രി ഷെഫ്",
    "navPlanner": "ആഴ്ചയിലെ ഭക്ഷണ പ്ലാനർ",
    "navCommunity": "കമ്മ്യൂണിറ്റി ഫീഡ്",
    "heroTitle": "ഇനി ഒരിക്കലും <span>'ഇന്ന് എന്താണ് പാചകം ചെയ്യേണ്ടത്?'</span> എന്ന് ചോദിക്കേണ്ടതില്ല.",
    "heroSubtitle": "MyMenuBuddy നിങ്ങളുടെ സ്വകാര്യ AI അടുക്കള സഹായിയാണ്. വീട്ടിലുള്ള സാധനങ്ങൾ ഓർമ്മയിൽ സൂക്ഷിക്കുകയും കുടുംബത്തിന്റെ അളവിനനുസരിച്ച് 150+ ദക്ഷിണേന്ത്യൻ വിഭവങ്ങൾ നൽകുകയും ചെയ്യുന്നു.",
    "btnTrySimulator": "AI ഷെഫുമായി സംസാരിക്കുക",
    "btnExploreRecipes": "150+ വിഭവങ്ങൾ കണ്ടെത്തുക",
    "statRecipes": "150 ദക്ഷിണേന്ത്യൻ വിഭവങ്ങൾ",
    "statStates": "5 ദക്ഷിണേന്ത്യൻ സംസ്ഥാനങ്ങൾ",
    "statLanguages": "മലയാളം ഉൾപ്പെടെ ബഹുഭാഷ",
    "statPortions": "അളവുകൾ ക്രമീകരിക്കാം",
    "simTitle": "ഇന്ററാക്ടീവ് AI കിച്ചൻ അസിസ്റ്റന്റ്",
    "simSubtitle": "എന്ത് പാചകം ചെയ്യണമെന്ന് തീരുമാനിക്കാനും റെസിപ്പികൾ കണ്ടെത്താനും MyMenuBuddy-യോട് ചോദിക്കുക.",
    "simOnline": "AI അസിസ്റ്റന്റ് • ഓൺലൈൻ",
    "simInputPlaceholder": "എന്ത് പാചകം ചെയ്യണമെന്ന് ചോദിക്കുക, അല്ലെങ്കിൽ /cook, /recipe ടൈപ്പ് ചെയ്യുക...",
    "simSendTooltip": "സന്ദേശം അയയ്ക്കുക",
    "simBotName": "MyMenuBuddy AI കിച്ചൻ അസിസ്റ്റന്റ്",
    "simBotStatus": "സജീവം • ഓൺലൈൻ",
    "simChipCook": "👩‍🍳 ഇന്ന് എന്താണ് പാചകം?",
    "simChipBiryani": "🍗 ബിരിയാണി",
    "simChipDosa": "🥞 നെയ്യ് ദോശ",
    "simChipPantry": "🥬 എന്റെ പാൻട്രി",
    "simChipPlan": "📅 7 ദിവസത്തെ പ്ലാൻ",
    "searchPlaceholder": "വിഭവങ്ങൾ, ചേരുവകൾ അല്ലെങ്കിൽ സംസ്ഥാനം തിരയുക...",
    "filterAllDiets": "എല്ലാ ഭക്ഷണങ്ങളും",
    "filterVeg": "🥦 വെജിറ്റേറിയൻ (Veg)",
    "filterNonVeg": "🍗 നോൺ-വെജ് (Non-Veg)",
    "filterVegan": "🌱 വീഗൻ",
    "filterJain": "🕉 ജൈൻ",
    "filterAllTimings": "എല്ലാ സമയങ്ങളും",
    "filterBreakfast": "🥞 ಪ್ರഭാതഭക്ഷണം",
    "filterLunch": "🍛 ഉച്ചഭക്ഷണം",
    "filterDinner": "🥘 അത്താഴം",
    "filterSnack": "☕ വൈകുന്നേരത്തെ ചായക്കടി",
    "filterQuick": "⚡ < 20 മിനിറ്റ്",
    "regionAll": "📍 എല്ലാ 5 സംസ്ഥാനങ്ങളും (150 വിഭവങ്ങൾ)",
    "regionTN": "🌴 തമിഴ്നാട് (30)",
    "regionKerala": "🥥 കേരളം (30)",
    "regionKarnataka": "🌾 കർണാടക (30)",
    "regionAndhra": "🌶️ ആന്ധ്രാപ്രദേശ് (30)",
    "regionTelangana": "🏛️ തെലങ്കാന (30)",
    "recipesSearching": "സ്വാദിഷ്ടമായ വിഭവങ്ങൾ തിരയുന്നു...",
    "recipesFound": "വിഭവങ്ങൾ കണ്ടെത്തി",
    "emptyRecipesTitle": "വിഭവങ്ങളൊന്നും കണ്ടെത്താനായില്ല",
    "emptyRecipesDesc": "ഫിൽട്ടറുകൾ മാറ്റി തിരയുക അല്ലെങ്കിൽ 'ദോശ', 'ഇഡ്ഡലി' എന്ന് ടൈപ്പ് ചെയ്യുക.",
    "cardVegBadge": "🥦 വെജ്",
    "cardNonVegBadge": "🍗 നോൺ-വെജ്",
    "cardMins": "മിനിറ്റ്",
    "cardKeyIngs": "പ്രധാന ചേരുവകൾ:",
    "cardScales": "👨‍👩‍👧 1-8+ ആളുകൾക്ക് അളവ്",
    "cardEasy": "⚡ എളുപ്പം",
    "btnRecipeAndPortions": "കൂട്ടുകളും അളവുകളും",
    "modalCookingTime": "പാചക സമയം:",
    "modalRegion": "സ്ഥലം:",
    "modalDiet": "ഭക്ഷണ തരം:",
    "modalServings": "അളവ്:",
    "modalPortionScalerTitle": "ആളുകളുടെ എണ്ണത്തിനനുസരിച്ച് അളവ് മാറ്റുക:",
    "modalScaleSubtitle": "കുടുംബാംഗങ്ങളുടെ എണ്ണം തിരഞ്ഞെടുക്കുക",
    "modalPersons": "ആളുകൾ",
    "modalIngredientsTitle": "ആവശ്യമായ ചേരുവകൾ",
    "modalStepByStepTitle": "പാചക രീതി (ഘട്ടം ഘട്ടമായി)",
    "modalOpenInBot": "Telegram Bot-ൽ കാണുക",
    "modalNutritionBadge": "പോഷക സമ്പുഷ്ടം",
    "modalPrepNotice": "ശുദ്ധമായ ചേരുവകൾ ഉപയോഗിച്ച് തയ്യാറാക്കുക",
    "pantryTitle": "സ്മാർട്ട് പാൻട്രി ഷെഫ്",
    "pantrySubtitle": "വീട്ടിലുള്ള ചേരുവകൾ തിരഞ്ഞെടുത്ത് തൽക്ഷണം പാചക നിർദ്ദേശങ്ങൾ നേടുക.",
    "plannerTitle": "7 ദിവസത്തെ ഭക്ഷണ പ്ലാനർ",
    "plannerSubtitle": "ആരോഗ്യകരവും സന്തുലിതവുമായ പ്രതിവാര ഭക്ഷണക്രമം.",
    "fHome": "ഹോം",
    "fAssistant": "AI അസിസ്റ്റന്റ്",
    "fRecipes": "150 വിഭവങ്ങൾ",
    "fPantry": "പാൻട്രി ഷെഫ്",
    "fPlanner": "ആഴ്ചയിലെ പ്ലാൻ",
    "fCookToday": "ഇന്ന് എന്താണ് പാചകം?",
    "fPortionScaler": "അളവ് സ്കെയിലർ",
    "fPantryMatcher": "പാൻട്രി മാച്ചർ",
    "fMasterclass": "സ്റ്റെപ്പ്-ബൈ-സ്റ്റെപ്പ് രീതി",
    "fGroceryList": "പലചരക്ക് ലിസ്റ്റ്",
    "fTamilNadu": "തമിഴ്നാട് സ്പെഷ്യൽ",
    "fKerala": "കേരള തനിമ",
    "fAndhra": "ആന്ധ്രാ വിഭവങ്ങൾ",
    "fNorthIndian": "കർണാടക വിഭവങ്ങൾ",
    "fGlobal": "തെലങ്കാന വിഭവങ്ങൾ",
    "fCopyright": "© 2026 MyMenuBuddy. എല്ലാ അവകാശങ്ങളും നിക്ഷിപ്തം.",
    "fBadge": "പൂർണ്ണ React + Node.js ആപ്പ്",
    "fBackToTop": "മുകളിലേക്ക് ↑",
    "btnFullscreen": "ഫുൾ സ്ക്രീൻ",
    "btnExitFullscreen": "സാധാരണ സ്ക്രീൻ",
    "settingsTitle": "ക്രമീകരണങ്ങളും ഭാഷയും",
    "settingsLanguage": "ഭാഷ തിരഞ്ഞെടുക്കുക",
    "settingsLanguageDesc": "മലയാളം, தமிழ், ಕನ್ನಡ, తెలుగు, हिंदी, ഇംഗ്ലീഷ് എന്നിവയിലേക്ക് മാറുക",
    "settingsDiet": "ഭക്ഷണ മുൻഗണന",
    "settingsServings": "കുടുംബാംഗങ്ങളുടെ എണ്ണം",
    "settingsClose": "അടയ്ക്കുക",
    "simChipSettings": "⚙️ ക്രമീകരണങ്ങൾ",
    "simSidebarTitle": "💡 MyMenuBuddy പ്രധാന സവിശേഷതകൾ:",
    "simSidebarFeature1": "1. പുതിയ നിർദ്ദേശങ്ങൾ: വിഭവങ്ങൾ ആവർത്തിക്കാതെ ഓരോ തവണയും പുതിയ ഭക്ഷണങ്ങൾ.",
    "simSidebarFeature2": "2. ബഹുഭാഷാ പിന്തുണ: ചേരുവകളും പാചകരീതികളും മലയാളത്തിൽ ലഭ്യമാണ്.",
    "simSidebarFeature3": "3. ഡൈനാമിക് അളവുകൾ: 1 മുതൽ 8+ ആളുകൾക്ക് അനുയോജ്യമായ അളവുകൾ.",
    "simSidebarFeature4": "4. പാൻട്രി പാചകം: വീട്ടിലുള്ള ചേരുവകൾ കൊണ്ട് തത്സമയം ഉണ്ടാക്കാവുന്ന വിഭവങ്ങൾ.",
    "simSidebarCardTitle": "✨ വ്യക്തിഗത പാചകം",
    "simSidebarCardDesc": "ദക്ഷിണേന്ത്യൻ നാടൻ രുചികൾ നിമിഷങ്ങൾക്കുള്ളിൽ കണ്ടെത്തൂ!",
    "simSidebarCardBtn": "150+ റെസിപ്പികൾ കാണുക",
    "simWelcomeText": "🙏 <b>സ്വാഗതം! ഞാൻ MyMenuBuddy AI അടുക്കള സഹായി!</b> 👩‍🍳\n\nഇന്ന് എന്താണ് ഉണ്ടാക്കേണ്ടതെന്ന് തീരുമാനിക്കാനും, ആളുകളുടെ എണ്ണത്തിനനുസരിച്ച് ചേരുവകൾ കണക്കാക്കാനും ഞാൻ സഹായിക്കാം.\n\n✨ <b>എന്റെ സേവനങ്ങൾ:</b>\n• 👩‍🍳 <b>ഇന്ന് എന്താണ് പാചകം?:</b> പ്രാതൽ, ഉച്ചയൂണ്, അത്താഴം എന്നിവയ്ക്കുള്ള ആശയങ്ങൾ\n• ⚖️ <b>സ്മാർട്ട് പോർഷൻ സ്കെയിലർ:</b> 1 മുതൽ 8+ ആളുകൾക്കുള്ള അളവുകൾ\n• 🥬 <b>പാൻട്രി പാചകം:</b> കയ്യിലുള്ള ചേരുവകൾ കൊണ്ടുള്ള രുചികരമായ വിഭവങ്ങൾ\n• 🔍 <b>150+ നാടൻ വിഭവങ്ങൾ:</b> ഘട്ടം ഘട്ടമായുള്ള പാചകക്കുറിപ്പുകൾ\n• 📅 <b>7-ദിവസത്തെ പ്ലാനർ:</b> പ്രതിവാര ഭക്ഷണക്രമവും പലചരക്ക് ലിസ്റ്റും\n\nതാഴെയുള്ള ബട്ടൺ ക്ലിക്ക് ചെയ്യുകയോ പാചക സംശയങ്ങൾ ചോദിക്കുകയോ ചെയ്യാം!",
    "simWelcomeButtons": [
      [
        {
          "text": "👩‍🍳 ഇന്ന് എന്താണ് പാചകം?",
          "action": "cmd_cook"
        },
        {
          "text": "🔍 റെസിപ്പി തിരയൂ",
          "action": "cmd_find"
        }
      ],
      [
        {
          "text": "🥬 എന്റെ പാൻട്രി",
          "action": "cmd_pantry"
        },
        {
          "text": "📅 7-ദിവസത്തെ പ്ലാൻ",
          "action": "cmd_plan"
        }
      ],
      [
        {
          "text": "⚙️ പ്രൊഫൈൽ ക്രമീകരണങ്ങൾ",
          "action": "cmd_start"
        }
      ]
    ],
    "recipeTitle": "തനത് പ്രാദേശിക പാചകക്കുറിപ്പുകളുടെ ശേഖരം",
    "recipeSubtitle": "കേരളം, തമിഴ്നാട്, കർണാടക, ആന്ധ്ര, തെലങ്കാന സംസ്ഥാനങ്ങളുടെ 150-ലധികം വിഭവങ്ങൾ ആളുകളുടെ എണ്ണത്തിനനുസരിച്ച് പാചകം ചെയ്യൂ.",
    "btnAskChef": "💬 AI-യോട് ചോദിക്കൂ",
    "btnAskChefTitle": "AI അടുക്കള സഹായിയോട് ഈ വിഭവത്തെക്കുറിച്ച് ചോദിക്കൂ",
    "modalPortionLabel": "⚖️ അളവ് ക്രമീകരണം (ആളുകളുടെ എണ്ണം):",
    "modalPortion1to2": "👤 1-2 ആളുകൾ (0.5x)",
    "modalPortion3to4": "👨‍👩‍👧 3-4 ആളുകൾ (1x)",
    "modalPortion5to6": "👨‍👩‍👧‍👦 5-6 ആളുകൾ (1.5x)",
    "modalPortion8plus": "🎉 8+ വിരുന്ന് (2x)",
    "modalTabSummary": "📋 ചേരുവകളും പാചകരീതിയും",
    "modalTabMasterclass": "👩‍🍳 മാസ്റ്റർക്ലാസ് ഗൈഡ്",
    "modalPart": "ഭാഗം",
    "modalReqIngredients": "🛒 ആവശ്യമായ ചേരുവകൾ ({headcount} പേർക്ക്):",
    "modalQuickMethod": "⚡ എളുപ്പവഴി:",
    "modalMasterclassBanner": "👩‍🍳 <b>മാസ്റ്റർക്ലാസ് മോഡ്:</b> ഓരോ ഘട്ടവും പൂർത്തിയാക്കി ടിക്ക് ചെയ്യുക. പാചക ടൈമർ ഉപയോഗിക്കുക!",
    "modalStep": "ഘട്ടം",
    "modalTimerLabel": "⏱ പാചക ടൈമർ:",
    "modalTimerStart": "ആരംഭിക്കുക",
    "modalTimerPause": "നിർത്തുക",
    "modalTimerReset": "റീസെറ്റ്",
    "modalBtnCopy": "📋 റെസിപ്പി കോപ്പി ചെയ്യുക",
    "modalBtnAskAI": "💬 AI സഹായിയോട് ചോദിക്കൂ",
    "modalCopyAlert": "✅ പാചകക്കുറിപ്പും അളവുകളും കോപ്പി ചെയ്തു!",
    "modalPeople": "ആളുകൾ",
    "pantryInputPlaceholder": "ചേരുവയുടെ പേര് ടൈപ്പ് ചെയ്ത് Enter അമർത്തുക (ഉദാ: പനീർ, ചിക്കൻ, ഉരുളക്കിഴങ്ങ്)...",
    "pantryBtnAdd": "ചേരുവ ചേർക്കുക",
    "pantryBtnDefaults": "സാധാരണയുള്ളവ",
    "pantryBtnClear": "എല്ലാം ഒഴിവാക്കുക",
    "pantryTapToggle": "💡 വേഗത്തിൽ ചേർക്കാൻ ഏതെങ്കിലും ചേരുവയിൽ ക്ലിക്ക് ചെയ്യുക:",
    "pantryInventoryHeading": "🥬 നിങ്ങളുടെ പാൻട്രി ലിസ്റ്റ്:",
    "pantryInBasket": "പാൻട്രിയിലുള്ള സാധനങ്ങൾ ({count})",
    "pantryItemsCount": "ഇനങ്ങൾ",
    "pantryEmptyInventory": "ചേരുവകൾ ഒന്നും തിരഞ്ഞെടുത്തിട്ടില്ല. മുകളിൽ നിന്ന് തിരഞ്ഞെടുക്കൂ!",
    "pantryResultsHeading": "✨ ഈ ചേരുവകൾ കൊണ്ട് ഉണ്ടാക്കാവുന്ന വിഭവങ്ങൾ:",
    "pantryCalculating": "അനുയോജ്യമായ വിഭവങ്ങൾ കണക്കാക്കുന്നു...",
    "pantryEmptyMatches": "ഉണ്ടാക്കാൻ കഴിയുന്ന വിഭവങ്ങൾ അറിയാൻ മുകളിൽ ചേരുവകൾ ചേർക്കുക!",
    "pantryMatchScore": "പൊരുത്തം",
    "pantryAllIngsReady": "✅ എല്ലാ പ്രധാന ചേരുവകളും നിങ്ങളുടെ പക്കലുണ്ട്!",
    "pantryNeed": "ആവശ്യമായവ: ",
    "pantryMore": "കൂടുതൽ",
    "pantryBtnCookThis": "പാചകം ചെയ്യുക",
    "plannerPresetTamil": "🌴 ദക്ഷിണേന്ത്യൻ നാടൻ വിഭവങ്ങൾ",
    "plannerPresetHealthy": "🥗 ഹൈ പ്രോട്ടീൻ ആരോഗ്യ ഭക്ഷണം",
    "plannerBtnCopy": "📋 പ്രതിവാര പലചരക്ക് ലിസ്റ്റ് കോപ്പി ചെയ്യുക",
    "plannerCopiedAlert": "📋 7-ദിവസത്തെ പ്ലാനും പലചരക്ക് ലിസ്റ്റും കോപ്പി ചെയ്തു!",
    "plannerDays": {
      "Monday": "തിങ്കൾ",
      "Tuesday": "ചൊവ്വ",
      "Wednesday": "ബുധൻ",
      "Thursday": "വ്യാഴം",
      "Friday": "വെള്ളി",
      "Saturday": "ശനി",
      "Sunday": "ഞായർ"
    },
    "plannerSlots": {
      "b": "🥞 പ്രാതൽ",
      "l": "🍛 ഉച്ചയൂണ്",
      "s": "☕ വൈകുന്നേരത്തെ പലഹാരം",
      "d": "🥘 അത്താഴം"
    },
    "footerDesc": "MyMenuBuddy — കുടുംബങ്ങളുടെ ദൈനംദിന പാചകം ലളിതമാക്കുന്ന AI പ്ലാറ്റ്ഫോം.",
    "footerCol1Title": "പ്രധാന ലിങ്കുകൾ",
    "footerCol2Title": "AI സവിശേഷതകൾ",
    "footerCol3Title": "പ്രാദേശിക വിഭവങ്ങൾ"
  }
};
